

jQuery.expr[':'].icontains = function (a, i, m) {
    return jQuery(a).text().toUpperCase()
            .indexOf(m[3].toUpperCase()) >= 0;
};



var Url = function () {

    var query = window.location.search.substring(1),
        vars = query.split("&"),
        i = 0;

    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair.length !== 2) continue;
        this[pair[0]] = pair[1];
    }

};

function defined(variable) {

    if (typeof variable !== 'undefined') {
        // the variable is defined
        return true
    }
    return false;
}

if (typeof Vue !=='undefined') {
    Vue.component('v-select', VueSelect.VueSelect);
    Vue.component('bootstrap-modal', Vue2BootstrapModal);
}

Date.prototype.addDays = function(days) {
    var date = new Date(this.valueOf());
    date.setDate(date.getDate() + days);
    return date;
}


//Inicializamos variable xhr, que servirá para asignar consultas ajax, y cancelarlas
// si realizamos múltiples consultas y queremos abortar las anteriores. Ej: Al buscar usuarios en el servidor via ajax
var xhr;

function cl(string) {
    // Script cl
}

function location_reload() {
    location.reload();
}

Url.prototype._set = function (start) {

    var res = '';
    start = start || "";

    if (Object.keys(this).length > 0) {
        var self = this;
        res = start + '?' + $.map(Object.getOwnPropertyNames(self),
                function (k) {
                    return [k, self[k]].join('=');
                }).join('&');
    }

    if (window.location.search !== res) window.location.search = res;

};

var url = new Url();

Number.prototype.pad = function (padString, length) {
    var str = this.toString();
    while (str.length < length)
        str = padString + str;
    return str;
};


function process_response(msg, parent, response_element, silent_success) {

    var scrollTo = true;
    if (typeof msg.data!=='undefined' && typeof msg.data.scrollTo!=='undefined' && msg.data.scrollTo==false)
        scrollTo = false;

    var slient_success = silent_success || false;
    parent = parent || $();
    parent.find('input').removeClass('error ok');
    $(response_element).html('');

    if (typeof msg === 'object') {
        if (typeof msg.data !=='undefined') {
            if (typeof msg.data.options !== 'undefined') {
                if (typeof  msg.data.options.modal !== 'undefined') {
                    if (typeof  msg.data.options.forzarefectivo !== 'undefined') {
                        modal_c({
                            'title': '',
                            'text': msg.data.msg,
                            'size': 'md',
                            'button': {'close': Lang.get('msg.close'), 'ok': Lang.get('msg.ok')}
                        });
                        return false;
                    } else {
                        modal_c({
                            'title': '',
                            'text': msg.data.msg,
                            'size': 'md',
                            'button': {'close': Lang.get('msg.close')}
                        });
                        return false;
                    }
                }
            }
        }

        if (msg.status == 'ok' && slient_success === false) {

            var msg_content = null;
            if (typeof msg.data === 'object') {
                msg_content = msg.data.msg;

                if ('redirect' in msg.data) {
                    var redirect = msg.data.redirect;
                    msg_content += '</br> ' + Lang.get('msg.esperando_redireccion');
                    setTimeout(function () {
                        window.location = redirect.url;
                    }, redirect.wait * 1000);
                    parent.find('button,input[type=submit]').prop('disabled', true);
                }

                if ('reload' in msg.data) {
                    var wait = 0;
                    if (msg.data.reload.wait!=='undefined')
                        wait = msg.data.reload.wait;
                    msg_content += '</br> ' + Lang.get('msg.esperando_redireccion');
                    setTimeout(function () {
                        location.reload();
                    }, wait * 1000);
                    parent.find('button,input[type=submit]').prop('disabled', true);
                }

            } else {
                msg_content = msg.data;
            }

            $(response_element).html('<div id="message-response" class="msg msg-ok">'
                + '<i class="fa fa-check"></i>' + msg_content + "</div>");

            parent.find('input').addClass('ok');

            if(scrollTo) {
                $('html,body').animate({
                    scrollTop: $("#message-response").offset().top - 80
                }, 500, 'swing');
            }

        } else if (msg.status == 'error' || msg.status == 'fail') {

            if (typeof msg.data.errors === 'object') {

                var errors = Object.keys(msg.data.errors).forEach(function (key) {
                    parent.find('input[name="' + key + '"]').addClass('error');
                    var label = parent.find('label[for="' + key + '"]');
                    var title = label.length === 0 ? key : label.text();
                    response_element.append('<div class="msg msg-error alignleft"><strong>' + title + '</strong> ' + msg.data.errors[key] + '</div>');
                });

                parent.find('input:not(.error)').addClass('ok');

            } else {

                if(msg.data.fieldError !== undefined){
                    parent.find('input').addClass('ok');
                    parent.find('select').addClass('ok');
                    //parent.find('input').removeAttr("autofocus");
                    var errorField = parent.find('input[name ="'+ msg.data.fieldError +'"]')[0];
                    if (errorField == undefined){
                        errorField = parent.find('select[name ="'+ msg.data.fieldError +'"]')[0];
                    }

                    //console.log($(errorField));
                    $(errorField).removeClass('ok');
                    $(errorField).addClass('error');
                    //El focus NO funciona, caldria revisar-ho a fons, però de moment marcar en vermell el camp que falla ja es una millora (abans sortien tots vermells)
                    //$(inputField).attr("autofocus","autofocus");
                    //inputField.focus();
                    //$(inputField).focus();
                }
                // else{
                //     parent.find('input').addClass('error');
                // }


                var text = '';
                if (typeof(msg.data.msg) !== 'undefined') {
                    text = msg.data.msg;
                } else {
                    text = msg.data.errors;
                }
                response_element.html('<div id="message-response" class="msg msg-error">' + text + "</div>");

                // $('html,body').animate({
                //     scrollTop: $("#message-response").offset().top - 80
                // }, 500, 'swing');

            }
        }

    } else {
        response_element.html(msg);
    }

    response_element.stop().animate({'min-height': 0});

    return msg.status;

}

function hover_spinner(parent) {
    var sp = new Spinner().spin();
    parent.append(sp.el);
}

function stop_hover_spinner(parent) {
    parent.find('.spinner').remove();
}

function spinner(parent) {
    var sp = new Spinner().spin();
    parent.css({'min-height': parent.outerHeight()});
    parent.html('');
    parent.append(sp.el);
}

function disable_inputs($form) {
    $form.find(':input:not(:disabled)').addClass('disabled').prop('disabled', true);
}

function enable_inputs($form) {
    $form.find('.disabled:input:disabled').removeClass('disabled').prop('disabled', false);
}

function getDataAttr(element){
    var data_attr = element.data();
    var data_attr_ = {};

    $.each(data_attr, function (index, value) {
        if (index === 'ws') {
            data_attr_[index] = value;
        }
        if (index.length > 2) {
            data_attr_[index.toLowerCase()] = value;
        }
    });
    return data_attr_;
}

$(document).on('click', '.toggle-password-visibility', function () {
    var $input = $(this).closest('.password-toggle-group').find('input');
    var visible = $input.attr('type') === 'text';
    $input.attr('type', visible ? 'password' : 'text');
    $(this).find('i').toggleClass('fa-eye', visible).toggleClass('fa-eye-slash', !visible);
});

/**
 * Método encargado de mostrar el modal de socio encontrado por NIF.
 * @param {*} msg 
 * @param {*} form 
 * @param {*} response_element 
 */
function actividad_inscripcion_nif_verificacion(msg, form, response_element) {
    var data = msg.data || {};
    var socio = data.socio || {};
    var csrf = form.find('input[name="_token"]').val();
    var resumen = '';

    if (socio.nombre) {
        resumen += '<p><strong>' + Lang.get('socio.nombre') + ':</strong> ' + stripHTML(socio.nombre) + '</p>';
    }
    if (socio.email) {
        resumen += '<p><strong>' + Lang.get('socio.email') + ':</strong> ' + stripHTML(socio.email) + '</p>';
    }

    var html = '' +
        '<div id="actividadNifVerificationModal" class="modal fade">' +
        '   <div class="modal-dialog">' +
        '       <div class="modal-content">' +
        '           <div class="modal-header">' +
        '               <button type="button" class="close" data-dismiss="modal">&times;</button>' +
        '               <h4 class="modal-title">' + stripHTML(data.title || '') + '</h4>' +
        '           </div>' +
        '           <div class="modal-body">' +
        '               <div class="actividad-nif-verificacion-resumen">' +
        '                   <p>' + stripHTML(data.msg || '') + '</p>' +
                            resumen +
        '               </div>' +
        '               <div class="actividad-nif-verificacion-code hidden">' +
        '                   <p>' + stripHTML(data.code_msg || '') + '</p>' +
        '                   <input type="text" class="form-control actividad-nif-verificacion-input" maxlength="6" autocomplete="one-time-code" />' +
        '               </div>' +
        '               <div class="actividad-nif-verificacion-response"></div>' +
        '           </div>' +
        '           <div class="modal-footer">' +
        '               <button type="button" class="btn btn-default" data-dismiss="modal">' + Lang.get('msg.close') + '</button>' +
        '               <button type="button" class="btn btn-primary actividad-nif-verificacion-send">' + stripHTML(data.send_msg || '') + '</button>' +
        '               <button type="button" class="btn btn-success actividad-nif-verificacion-verify hidden">' + stripHTML(data.verify_msg || '') + '</button>' +
        '           </div>' +
        '       </div>' +
        '   </div>' +
        '</div>';

    $('#actividadNifVerificationModal').remove();
    $('body').append(html);

    var modal = $('#actividadNifVerificationModal');
    var modal_response = modal.find('.actividad-nif-verificacion-response');

    function mostrar_mensaje_temporal_fuera_modal(text) {
        $('#actividadNifVerificationToast').remove();

        var toast = $(
            '<div id="actividadNifVerificationToast" class="msg msg-error" style="' +
            'position:fixed;' +
            'top:20px;' +
            'left:50%;' +
            'transform:translateX(-50%);' +
            'z-index:20000;' +
            'max-width:520px;' +
            'width:calc(100% - 30px);' +
            'text-align:center;' +
            'box-shadow:0 4px 12px rgba(0,0,0,0.25);' +
            '">' + stripHTML(text || '') + '</div>'
        );

        $('body').append(toast);

        setTimeout(function () {
            toast.fadeOut(200, function () {
                toast.remove();
            });
        }, 2000);
    }

    modal.find('.actividad-nif-verificacion-send').on('click', function () {
        var button = $(this);
        button.prop('disabled', true);
        modal_response.html('');

        $.post(data.send_url, {
            _token: csrf,
            nif: data.nif,
            token: data.token
        }).done(function (res) {
            if (res.status === 'ok') {
                modal.find('.actividad-nif-verificacion-code').removeClass('hidden');
                modal.find('.actividad-nif-verificacion-verify').removeClass('hidden');
                modal.find('.actividad-nif-verificacion-input').focus();
                modal_response.html('<div class="msg msg-ok">' + res.data.msg + '</div>');
            } else if (res.status === 'expired') {
                modal.modal('hide');
                mostrar_mensaje_temporal_fuera_modal(res.data.msg);
            } else {
                modal_response.html('<div class="msg msg-error">' + res.data.msg + '</div>');
                button.prop('disabled', false);
            }
        }).fail(function () {
            modal_response.html('<div class="msg msg-error">Error</div>');
            button.prop('disabled', false);
        });
    });

    modal.find('.actividad-nif-verificacion-verify').on('click', function () {
        var button = $(this);
        button.prop('disabled', true);
        modal_response.html('');

        $.post(data.verify_url, {
            _token: csrf,
            nif: data.nif,
            token: data.token,
            code: modal.find('.actividad-nif-verificacion-input').val()
        }).done(function (res) {
            if (res.status === 'ok') {
                modal.modal('hide');
                response_element.html('<div id="message-response" class="msg msg-ok">' + res.data.msg + '</div>');
                window.location.reload();
            } else if (res.status === 'expired') {
                modal.modal('hide');
                mostrar_mensaje_temporal_fuera_modal(res.data.msg);
            } else {
                modal_response.html('<div class="msg msg-error">' + res.data.msg + '</div>');
                button.prop('disabled', false);
            }
        }).fail(function () {
            modal_response.html('<div class="msg msg-error">Error</div>');
            button.prop('disabled', false);
        });
    });

    modal.find('.actividad-nif-verificacion-input').on('keyup', function (e) {
        if (e.keyCode === 13) {
            modal.find('.actividad-nif-verificacion-verify').click();
        }
    });

    modal.modal({backdrop: 'static'}, 'show');
}

function submit_form(form, data) {

    var response_element = typeof form.attr('data-response') === 'undefined' ?
        form.find('.response') : $(form.attr('data-response'));

    if (!response_element.length) {
        response_element = $('#main-response');
    }

    var data_attr_ = getDataAttr(form);

    if (typeof data_attr_['start'] !== 'undefined') {
        executeFunctionByName(data_attr_['start'], window);
    }


    data = data || form.serializeArray();

    if (form[0].id == "event-form") {

        var jugadors = [];
        $(".assistants ul li").each(function () {
            if ($(this).attr('id') !== 'afegir_soci')
                jugadors.push($(this).attr('id'));
        });

        data.push({name: "socis", value: jugadors});
        if (ownerId != null) {
            data.push({name: "owner_id", value: ownerId});
        }
    }

    response_element.show();
    spinner(response_element);

    $.ajax({

        type: form.attr('method'),
        url: form.attr('action'),
        data: data

    }).done(function (msg) {

        //if (msg.redirect !== undefined && msg.status!=='ok') {
        //    location.href = msg.redirect;
        //}

        if (msg.status === 'nif_verification_required') {
            $("#loading_spin").fadeOut(100);
            actividad_inscripcion_nif_verificacion(msg, form, response_element);
            return;
        }

        process_response(msg, form, response_element);
        if (typeof data_attr_['callback'] !== 'undefined') {
            executeFunctionByName(data_attr_['callback'], window, msg);
        }
        js_reload();

    }).fail(function (msg, status) {

        if(msg.status != 200){
            process_response({
                status: 'error',
                data: {
                    msg: 'Error inesperat: <strong>' + msg.status + '</strong> ' + msg.statusText
                }
            }, form, response_element);
        }

    }).always(function (data) {

        if ($('.response-debug').length) {
            $('.response-debug').html(JSON.stringify(data, null, 2));
        }

        waitToEnable = 1; //Esperem un segon per defecte a habilitar els controls de formulari
        if (typeof data.data === 'object') {
            if ('redirect' in data.data){
                var waitToEnable = data.data.redirect.wait; //Esperem x segons per tornar a habilitar els controls del formulari (per evitar "dobles clicks")
            }
        }
        setTimeout(function () {
            enable_inputs(form);
        }, waitToEnable * 1000);

    });

    disable_inputs(form);
}

function afegir_slots(qtt) {
    for (var i = 1; i <= qtt; i++) {
        afegir_slot_nou();
    }
}

function eliminar_slots(qtt) {
    for (var i = 1; i <= qtt; i++) {
        eliminar_slot();
    }
}

function afegir_slot_nou() {
    var afegir_soci_btn_id = 1;
    $("#socis-list li").each(function () {
        if (parseInt($(this).data('afegir_soci_btn_id')) >= afegir_soci_btn_id) {
            afegir_soci_btn_id = parseInt($(this).data('afegir_soci_btn_id')) + 1;
        }
    });

    var li = document.createElement("li");
    var tieneAbonoInvitado = $('#tieneAbonoInvitado');
    li.setAttribute("class", "msg msg-ok afegir_soci_btn");
    if(tieneAbonoInvitado.val() >= 1){
        li.setAttribute("style", "display:inline-block; cursor:pointer;");
    }
    else{
        li.setAttribute("style", "cursor:pointer;");
    }
    li.setAttribute("id", "afegir_soci");
    li.setAttribute("data-afegir_soci_btn_id", afegir_soci_btn_id);
    var i = document.createElement("i");
    i.setAttribute("class", "fa fa-plus");
    var text = document.createTextNode(Lang.get('reserva.Afegir_participant'));
    li.appendChild(i);
    li.appendChild(text);
    $("#socis-list").append(li);

    if(tieneAbonoInvitado.val() >= 1){
        var btn = document.createElement("btn");
        btn.setAttribute("data-id2", "3");
        btn.setAttribute("data-afegir_soci_btn_id2", afegir_soci_btn_id);
        btn.setAttribute("data-nombre", Lang.get('msg.Invitado'));
        btn.setAttribute("style", "margin-left: 4px; display:inline-block; cursor:pointer;");
        btn.setAttribute("class", "msg msg-warn anadir_usuario_invitado_directo");
        var textA = document.createTextNode(Lang.get('msg.tipopago_3') + " " + Lang.get('msg.Invitado'));
        btn.appendChild(textA);
        $("#socis-list").append(btn);
    }
}

function eliminar_slot() {
    var socisList = document.getElementById("socis-list");
    var nodes = socisList.getElementsByTagName("li");
    var numSlotsActual = nodes.length;
    var e = 0;
    while (e < numSlotsActual) {
        if ($(nodes[e]).hasClass('afegir_soci_btn')) {
            socisList.removeChild(nodes[e]);
            e = numSlotsActual;
        }
        e++;
    }
}

function slots() {

    var placesLliures = document.getElementById("libres_range");
    var placeslliures_num;

    if (placesLliures == null){
        placeslliures_num = 0;
    } else {
        placeslliures_num = placesLliures.value;
    }
    //Comprovar els slots actuals
    var socisList = document.getElementById("socis-list");
    var nodes = socisList.getElementsByTagName("li");
    var numSlotsActual = nodes.length;
    var placesTotals = placeslliures_num - numSlotsActual;
    var slotsLliures = contarSlotsLliures();

    var i = 0;

    if (placesTotals <= 0 && numSlotsActual > 0) {
        var slotsMantenir = numSlotsActual - slotsLliures;
        //alert (slotsMantenir);
        for (var i = 0; i > placesTotals + slotsMantenir; i--) {
            eliminar_slot();
        }
    }

    for (var i = slotsLliures; i < placeslliures_num; i++) {
        afegir_slot_nou();
    }

    function contarSlotsLliures() {
        var lliures = 0;
        for (var f = 0; f < numSlotsActual; f++) {
            //alert(socisList.childNodes[f].textContent);
            if ($(nodes[f]).hasClass('afegir_soci_btn')) {
                lliures++;
            }
        }
        return lliures;
    }

}

/*cal_event select socio*/

$('body').on('click', '#afegir_soci', function () {


    var anadir_usuario_invitado_btn = $(".anadir_usuario_invitado");
    var anadir_usuario_invitado_btn_destiny = anadir_usuario_invitado_btn;
    var anadir_usuario_invitado_btn_parent = anadir_usuario_invitado_btn.parent();
    anadir_usuario_invitado_btn_parent.empty();
    anadir_usuario_invitado_btn_parent.append(anadir_usuario_invitado_btn_destiny);

    var anadir_usuario_externo_btn = $(".anadir_usuario_externo");
    var anadir_usuario_externo_btn_destiny = anadir_usuario_externo_btn;
    var anadir_usuario_externo_btn_parent = anadir_usuario_externo_btn.parent();
    anadir_usuario_externo_btn_parent.empty();
    anadir_usuario_externo_btn_parent.append(anadir_usuario_externo_btn_destiny);

    var agefir_soci_btn = $(this),
        afegir_soci_btn_id = $(this).data('afegir_soci_btn_id'),
        sociosModalSearch = $("#select_socios_modal [name=search]"),
        sociosModalMessage = $("#select_socios_modal .message"),
        sociosModalTable = $("#select_socios_modal table");

    //Eliminamos el elemento <input #search_input_socios.search_table />, y lo regeneramos.
    //Antes solo cambiabamos el valor del Attr data-afegir_soci_btn_id, y cuando se realizaba un .keyup del objeto y cogíamos el data-afegir_soci_btn_id, nos devolvía el valor antiguo
    sociosModalSearch.remove();
    $("#select_socios_modal #search_div").append(
        '<input id="search_input_socios" data-afegir_soci_btn_id="'+afegir_soci_btn_id+'" placeholder="'+Lang.get('msg.select_socios_modal_table_info1')+'" class="form-control search_table" data-table="select_socios_modal_table" type="text" name="search"/>'
    );

    $(".anadir_usuario_invitado").attr('data-afegir_soci_btn_id', afegir_soci_btn_id);
    $(".anadir_usuario_invitado_btn_id").attr('data-afegir_soci_btn_id', afegir_soci_btn_id);

    $(".anadir_usuario_externo").attr('data-afegir_soci_btn_id', afegir_soci_btn_id);

    sociosModalMessage.addClass('hidden');
    sociosModalSearch.val('');


    if ($("[name='MOSTRAR_USUARIOS_BUSCAR_SERVIDOR']").val() == '1') {

        var name = '00000';
        afegir_soci_get_users({
            'name': name,
            'afegir_soci_btn_id': afegir_soci_btn_id,
            'loadModal': true,
        });
    } else {
        afegir_soci_get_users({
            'name': '',
            'afegir_soci_btn_id': afegir_soci_btn_id,
            'loadModal': true,
        });
    }


});

function afegir_soci_get_users(object) {

    var name = object.name;
    var sociosModal = $("#select_socios_modal");
    var afegir_soci_btn_id = object.afegir_soci_btn_id;


    var socis_list = $("#socis-list");
    var socis_list_li = socis_list.find('li');
    var excluded_ids = [];
    socis_list_li.each(function (i) {
        if (!isNaN($(this).attr('id'))) {
            excluded_ids.push($(this).attr('id'));
        }
        //if ($(this).attr('id') !== 'afegir_soci') {
        //    excluded_ids.push($(this).attr('id'));
        //}
    });

    var gamelvl_val = $("#gamelvl_range").val();
    if (typeof gamelvl_val == "undefined") gamelvl_val = 0;

    $.get('/sportssuite/manager.php?op=get_user_list&name=' + name + '&lvl=' + gamelvl_val + '&exclude_ids=' + excluded_ids, function (res) {

        var showNif = 0;
        if (typeof (res.data.showNif) !== 'undefined' && res.data.showNif == '1') {
            var showNif = 1;
        }
        var showTlf = 0;
        if (typeof (res.data.showTlf) !== 'undefined' && res.data.showTlf == '1') {
            var showTlf = 1;
        }

        if (typeof object.loadModal !== 'undefined' && object.loadModal == true) {

            sociosModal.modal({backdrop: 'static'}, 'show');
        }

        var sociosModalTableTbody = $("#select_socios_modal table tbody");
        sociosModalTableTbody.empty();

        var trContent;
        if(res.data.socios !== null){
            $.each(res.data.socios, function (index, value) {
                var nombre = value.n;
                if (showTlf == 1 && value.t !== null) {
                    nombre = nombre + '<br/>' + value.t;
                }
                if (showNif == 1 && value.nif !== null) {
                    nombre = nombre + '<br/>' + value.nif;
                }
                trContent += '<tr><td><div class="nameFriendly hidden">';
                trContent += removeDiacritics(nombre) + '</div><div><label><a class="select_socios_modal_checkbox btn btn-default" style="margin:0px;" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '"  data-id="' + value.id + '" data-nombre="' + value.n + '">OK</a></label></div></td><td>'
                if(value.info_ranking){
                    if (value.info_ranking.indexOf("1-") >= 0) { //1er en edicio anterior
                        trContent +='<span class="label label-gold" style="margin-right:6px;">' + value.info_ranking + '</span>';
                    }
                    else if (value.info_ranking.indexOf("2-") >= 0){ //2on en edicio anterior
                        trContent +='<span class="label label-silver" style="margin-right:6px;">' + value.info_ranking + '</span>';
                    }
                    else if(value.info_ranking.indexOf("3-") >= 0){ //3er en edicio anterior
                        trContent +='<span class="label label-bronze" style="margin-right:6px;">' + value.info_ranking + '</span>';
                    }
                    else{
                        trContent +='<span class="label label-success" style="margin-right:6px;">' + value.info_ranking + '</span>';
                    }
                }
                trContent += nombre + '</td></tr>';
            });
        }

        sociosModalTableTbody.append(trContent);

    });

}

function actualizarDuracionFijada(data){
    if (data.duracionFijada > 0){ //tenim durada fixada (si no arriba un -1)
        if($('input[name="duration"]')[0] !== undefined){ //Quan l'usuari es ADMIN permetem canviar duracions i no tenim l'input de name "duration" creat. Afegim protecció perquè no peti. Entrar per la següent condició (select[name="duration"])
            $('input[name="duration"]')[0].value = data.duracionFijada; //son minuts
            changeDurationOrTimeIni();
        }
        if($('select[name="duration"]')[0] !== undefined){
            $('select[name="duration"]')[0].value = data.duracionFijada; //son minuts
            changeDurationOrTimeIni();
        }
    }
}

function prepago_show_info() {

    var array_socios_menos_anfitrion = new Array();
    var array_socios = new Array();
    var i = 1;
    var id_mst_socios_responsable;
    $("#socis-list li").each(function (k, v) {
        if ($.isNumeric($(v).attr('id'))) {
            array_socios.push($(v).attr('id'));
            if ($(v).attr('data-responsable_paga')) {
                array_socios_menos_anfitrion.push($(v).attr('id'));
            }
            if (i == 1) {
                id_mst_socios_responsable = $(v).attr('id');
            }
            i = i + 1;
        }
    });

    var fecha_ini = $("[name=time_ini]").val();
    if($("[name=time_ini]").val().length <= 5){
        fecha_ini = $("[name=data]").val().substring(0, 11) + $("[name=time_ini]").val();
    }
    url = '/api/reserves/socios/' + array_socios_menos_anfitrion + '/prepago_show_info/recurso/' + $("[name=recurso]").val() + '/fecha/' + $("[name=data]").val() + '/fecha_ini/' + fecha_ini + '/duracion/' + $("[name=duration]").val() + '/id_mst_socios_responsable/' + id_mst_socios_responsable + '/socios/' + array_socios;
    if (array_socios_menos_anfitrion.length > 0) {
        $.get(url, function (data) {
            $("#prepago_show_info").html(data);
        });
    } else {
        $("#prepago_show_info").empty();
        url = '/api/reserves/socio/' + id_mst_socios_responsable + '/get_info/recurso/' + $("[name=recurso]").val() + '/fecha/' + $("[name=data]").val() + '/fecha_ini/' + $("[name=time_ini]").val() + '/duracion/' + $("[name=duration]").val() + '/id_reg_reserva/0/socios/' + array_socios;
        $.get(url, function (data) {
            actualizarDuracionFijada(data);
        });
    }
}

function t(key) {
    if (lang_strings !== undefined)
    {
        if (lang_strings.hasOwnProperty(key)) {
            return lang_strings[key];
        }
    }

    return key;

}

var selected_soci_btn_template = '<li class="msg msg-warn">'
    //+'<div class="row">'
    //+'<div class="userImageDiv"><img class="img-responsive thumbnail" src=""></div>'
    +'<div class="userNombre" style="margin-left: 10px"></div>'
    +'<div class="info1" style="margin-left: 10px"></div>'
    +'<button class="btn btn-default" style="margin-left: 10px" id="eliminar_soci">' + Lang.get('msg.delete') + '</button>'
    //+'</div>'
    +'</li>';

//24/04/2018 NO funciona crida a t() !!
//+'<button class="btn btn-default" style="margin-left: 10px" id="eliminar_soci">' + t('eliminar') + '</button>'

//Escollim l'usuari de dins el modal, en cal_event
$('body').on('click', '#select_socios_modal .select_socios_modal_checkbox', function (e) {

    // Les dades les obtindrem de l'element apretat
    var target = e.target;

    var id = target.attributes['data-id'].value,
        afegir_soci_btn_id = target.attributes['data-afegir_soci_btn_id'].value,
        nombre = target.attributes['data-nombre'].value, //.replace(/ - [0-9]/g, ""),
        sociosModalMessage = $("#select_socios_modal .message");

    nombre = nombre.replace(/[^a-zA-Z0-9- ]/g, ""); //eliminem caràcters especials per evitar problemes
    sociosModalMessage.html('');

    var url = '';

    var socis = [];


    if ($("[name=id_reserva]").val() > 0) {
        //Si té id_reserva
        url = '/api/reserves/socio/' + id + '/get_info/reserva/' + $("[name=id_reserva]").val();
    } else {
        var tiporeserva = $('#id_tiporeserva').find(":selected").val();
        $("#socis-list li").each(function (key, e) {
            socis.push();
            var id_ = parseInt($(e).attr('id'));
            if (!isNaN(id_)) {
                socis.push(id_);
            }
        });
        socis.push(id);
        url = '/api/reserves/socio/' + id + '/get_info/recurso/' + $("[name=recurso]").val() + '/fecha/' + $("[name=data]").val() + '/fecha_ini/' + $("[name=time_ini]").val() + '/duracion/' + $("[name=duration]").val() + '/id_reg_reserva/0/socios/' + socis;
    }

    $.ajax({
        type: 'GET',
        url: url,
        data: {id_mst_tiporeserva: tiporeserva},
        success: function (data) {
            if (data.error == 1) {
                sociosModalMessage.append(data.msg);
                sociosModalMessage.removeClass('hidden');
                $(".select_socios_modal_checkbox[data-id=" + id + "]").prop('checked', false);
                return;
            }

            actualizarDuracionFijada(data);

            if (parseInt(data.modo_prepago) === 3) {

                //Si es prepago
                var nSocisList = $("#socis-list li:not(.afegir_soci_btn)").length;
                if (parseInt(data.modo_prepago) == 1 && nSocisList > 0) {
                    select_socios_modal_checkbox_finish(data);
                    return;
                }

                if (parseInt(data.puede_reservar) === 1) {
                    select_socios_modal_checkbox_finish(data);
                } else {
                    if (data.responsable_paga) {
                        if (parseInt(data.responsable_paga) === 1) {
                            select_socios_modal_checkbox_finish(data);

                        }
                    }
                    sociosModalMessage.append(data.tipos_pago['0']['tooltip']);
                    sociosModalMessage.removeClass('hidden');
                    $(".select_socios_modal_checkbox[data-id=" + id + "]").prop('checked', false);
                }


                var responsable_paga = false;
                $("#socis-list").find('li').each(function (key, value) {
                    if ($(value).attr('data-responsable_paga') == '1') {
                        responsable_paga = true;
                    }
                });
                if (responsable_paga) { // ho girem perque als admin mostri la lista, ja que el pagament no el mostra
                    prepago_show_info();
                    pago_anticipado_select();
                }
                // prepago_show_info();
                update_widget_assistants_info();

            } else {
                //si es modo_prepago !== 3
                select_socios_modal_checkbox_finish(data);
            }

        },
        dataType: '',
        async: false
    });


    function select_socios_modal_checkbox_finish(data) {
        var nSocisList = $("#socis-list li:not(.afegir_soci_btn)").length;

        if (parseInt(data.modo_prepago) == 1) {
            //Pagament de tipus pagament total de la pista

            if (nSocisList == 0) {

                //Si sols hi ha un soci a la llista, és perquè estem fent una reserva a la part d'usuari com a administrador
                var creditos = '<p><strong>' + data.tipo_pago_escogido.nombre + ' / ' + data.tipo_pago_escogido.precio + ' ' + data.tipo_pago_escogido.unidades + '</strong></p>';
                var selected_soci_btn = '<li id="' + id + '" class="msg msg-warn" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '">' +
                    '<p>' + nombre + '</p>'
                    + creditos +
                    '<button class="btn btn-default" onclick="location.reload(true);">Canviar amfitrió</button></li>';
                $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);
                $("#select_socios_modal").modal('toggle');
                libres_restar();
                return;
            }


            if (nSocisList > 0) {
                //Si hi ha més d'un soci, estarem tractant l'inscrit nº 2,3,4... pel que aquest no haurà de pagar, ja paga el recurs l'usuari anfitrió
                var selected_soci_btn = '<li id="' + id + '" class="msg msg-warn" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '">' +
                    '<p>' + nombre + '</p>' +
                    '<button class="btn btn-default" id="eliminar_soci">' + Lang.get('msg.delete') + '</button></li>';
                $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);
                $("#select_socios_modal").modal('toggle');
                libres_restar();
                return;
            }
        }


        var creditos = '';
        if (typeof data.tipo_pago_escogido !== 'undefined') {
            if (data.tipo_pago_escogido.id_mst_tipopago === 5 || data.tipo_pago_escogido.id_mst_tipopago === 1) {
                //Moneder virtual
                creditos = '<p><strong>' + data.tipo_pago_escogido.nombre + ' / ' + data.tipo_pago_escogido.precio + ' ' + data.tipo_pago_escogido.unidades + '</strong></p>';
            } else {
                //Abonament
                var creditos_aux = '';
                if (typeof (data.tipo_pago_escogido.creditos) !== 'undefined') {
                    creditos_aux = ' / ' + data.tipo_pago_escogido.creditos + ' ' + data.tipo_pago_escogido.unidades;
                }
                if (data.tipo_pago_escogido.nombre)
                    creditos = '<p><strong>' + data.tipo_pago_escogido.nombre + creditos_aux + '</strong></p>';
            }
        }

        var selected_soci_btn = $(selected_soci_btn_template).clone();
        $(selected_soci_btn).attr('id',id);
        if (data.responsable_paga) {
            $(selected_soci_btn).attr('data-responsable_paga',1);
        }
        $(selected_soci_btn).attr('data-afegir_soci_btn_id',afegir_soci_btn_id);
        //$(selected_soci_btn).find('.userImageDiv img').attr('src',path_imagen);
        $(selected_soci_btn).find('.userNombre').html(nombre);
        $(selected_soci_btn).find('.userNombre').after(creditos);

        $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);
        var anadirInvitadoDirecto = $(".anadir_usuario_invitado_directo[data-afegir_soci_btn_id2="+afegir_soci_btn_id+ "]");
        if(anadirInvitadoDirecto != undefined){
            anadirInvitadoDirecto.remove(); //Si existeix eliminem botó de añadir invitado directo (pq ja hem triat un usuari i no té sentit que aparegui)
        }
        $("#select_socios_modal").modal('toggle');
        libres_restar();
    }

});


$('body').on('click', '.anadir_usuario_invitado_directo', function () {
    var id = $(this).attr('data-id2'),
        afegir_soci_btn_id = $(this).data('afegir_soci_btn_id2'),
        nombre = $(this).data('nombre');
    var array_socios = new Array();
    $("#socis-list li").each(function (k, v) {
        if ($.isNumeric($(v).attr('id'))) {
            array_socios.push($(v).attr('id'));
        }
    });
    array_socios.push(3);//Afegim el convidat que volem afegir pq calculi si té prou saldo correctament
    var url = '/api/abono/controlSaldoAbonoInvitados/socios/' + array_socios;
    // // Create a Deferred
    // var defer = $.Deferred();
    var objCall = $.get(url, function (data) {
        if(data !== "") {
            alert(data);
            if($("[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").find('#eliminar_soci') !== undefined)
            {
                $("[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").find('#eliminar_soci').click();
            }
            return; //mostrem missatge de saldo insuficient i retornem
        }
        else{
            //console.log("resolve");
            // defer.resolve("");
        }
    });

    // Set object as a promise
    // defer.promise( objCall );
    // objCall.done(function( status ) {
    // });

    //tot ok
    var selected_soci_btn = '<li id="' + id + '" class="msg msg-warn" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '"><p>' + nombre + '</p><button class="btn btn-default" id="eliminar_soci">' + Lang.get('msg.delete') + '</button></li>';
    $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);
    $(this).remove();
    libres_restar();
    prepago_show_info();

});

$('body').on('click', '#select_socios_modal .anadir_usuario_invitado', function () {
    var id = $(this).attr('data-id'),
        afegir_soci_btn_id = $(this).data('afegir_soci_btn_id'),
        nombre = $(this).data('nombre');

    var selected_soci_btn = '<li id="' + id + '" class="msg msg-warn" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '"><p>' + nombre + '</p><button class="btn btn-default" id="eliminar_soci">' + Lang.get('msg.delete') + '</button></li>';
    $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);

    $("#select_socios_modal").modal('toggle');

    libres_restar();
    prepago_show_info();
});

$('body').on('click', '#select_socios_modal .anadir_usuario_externo', function () {
    var id = $(this).attr('data-id'),
        afegir_soci_btn_id = $(this).data('afegir_soci_btn_id'),
        nombre = $(this).data('nombre');

    var selected_soci_btn = '<li id="' + id + '" class="msg msg-warn" data-afegir_soci_btn_id="' + afegir_soci_btn_id + '"><p>' + nombre + '</p><button class="btn btn-default" id="eliminar_soci">' + Lang.get('msg.delete') + '</button></li>';
    $(".afegir_soci_btn[data-afegir_soci_btn_id=" + afegir_soci_btn_id + "]").replaceWith(selected_soci_btn);
    $("#select_socios_modal").modal('toggle');
    libres_restar();
    prepago_show_info();
});


$('body').on('click', '#eliminar_soci', function () {

    //Revisar Pep Porcuna! 2017-09-01
    //var parent = this.parentElement;
    var parent = this.closest('.msg');
    var content = "<i class='fa fa-plus'></i>" + Lang.get('reserva.Afegir_participant');

    parent.setAttribute("class", "msg msg-ok afegir_soci_btn");
    parent.setAttribute("id", "afegir_soci");

    var tieneAbonoInvitado = $('#tieneAbonoInvitado');
    if(tieneAbonoInvitado.val() >= 1){
        parent.setAttribute("style", "display:inline-block; cursor:pointer;");
    }
    else{
        parent.setAttribute("style", "cursor:pointer;");
    }

    $(parent).html(content);

    if(tieneAbonoInvitado.val() >= 1){
        var btn = document.createElement("btn");
        btn.setAttribute("data-id2", "3");
        btn.setAttribute("data-afegir_soci_btn_id2", $(parent).attr("data-afegir_soci_btn_id"));
        btn.setAttribute("data-nombre", Lang.get('msg.Invitado'));
        btn.setAttribute("style", "margin-left: 4px; display:inline-block; cursor:pointer;");
        btn.setAttribute("class", "msg msg-warn anadir_usuario_invitado_directo");
        var textA = document.createTextNode(Lang.get('msg.tipopago_3') + " " + Lang.get('msg.Invitado'));
        btn.appendChild(textA);
        $(parent)[0].parentElement.insertBefore(btn, parent.nextSibling);
    }
    //$(this).parent().html(content);

    libres_sumar();
    prepago_show_info();

    if (typeof pago_anticipado_select === "function") {
        pago_anticipado_select();
    }
});

function libres_restar() {
    document.getElementById("libres_range").value--;
    document.getElementById("libres_value").value--;
    document.getElementById("libres_range").max--;
    document.getElementById("libres_value_show").value--;
    validate_form();
}

function libres_sumar() {
    document.getElementById("libres_range").max++;
    document.getElementById("libres_range").value++;
    document.getElementById("libres_value").value++;
    document.getElementById("libres_value_show").value++;
    validate_form();
}

$(document).on('keyup','.search_table',function () {

    // Exemple: <input type="text" class="search_table" data-table="usuaris_table" />
    //
    //<table id="usuaris_table">
    //...
    //</table>
    //

    if ($("[name='MOSTRAR_USUARIOS_BUSCAR_SERVIDOR']").val() == '1') {
        //Filtramos los socios via servidor
        if ($(this).val().length > 3) {
            afegir_soci_get_users({
                'name': $(this).val(),
                'afegir_soci_btn_id': $(this).data('afegir_soci_btn_id'),
                'loadModal': false,
            });
        }

    } else {
        //Filtramos por JS
        //split the current value of searchInput
        searchElements({'value':this.value,'elements':$("#" + $(this).data('table') + " tbody tr"),'explicit':true});
    }

});



function searchElements(options){

    /*
    * options.elements //Objecte en Jquery dels elements que s'ha de cercar/amagar/mostrar
    * options.value //Valor que busquem (el valor del input type text per exemple)
    * options.explicit  //Opcional. Si == true, fa la cerca de l'element sense separar-ho per espais. EX: valor "Soci Softneos" sols retorna els que es diguin "** Soci softneos **" (Asteriscos són comodí)
    *                   // Si == false, transforma el valor en array separat per espais, i mostra tots els elements que continguin algun dels elements de l'array. EX: valor "Soci Softneos", mostra tots els que es diguin "**Soci**" o "*Softneos*"
    *
    */

    function searchElementsExplicit(options){
        var data = options.value.split("|");
        var data = [removeDiacritics(data[0])];
        options.elements.addClass('hidden');
        options.elements.each(function (k, v) {
            if ($(v).is(":icontains('" + data + "')")) {
                $(v).removeClass('hidden');
            }
        });
    }

    function searchElementsNonExplicit(options){
        var data = options.value.split(" ");
        if (options.value.length==0){
            //Si dejan el buscador con 0 caracteres, mostramos todo_ otra vez
            options.elements.removeClass('hidden');
            return;
        }
        options.elements.addClass('hidden');
        $.each(data, function(kd,d){
            var d_ = [removeDiacritics(d)];
            if (d_[0].length>0) {
                options.elements.each(function (k, v) {
                    if ($(v).is(":icontains('" + d_ + "')")) {
                        $(v).removeClass('hidden');
                    }
                });
            }
        });
    }

    searchElementsExplicit(options);
    //09/01/2018. FEM SEMPRE CERQUES EXPLÍCITES!
    //if (typeof (options.explicit)!=='undefined' && options.explicit==true)
    //    searchElementsExplicit(options);
    //else
    //    searchElementsNonExplicit(options);
}

function message_show(msg) {
    if (msg.message !== undefined) {
        $('.message').empty();
        $.each(msg.message, function (i, val) {
            $('.message').append(val);
        });
    }
}


$(document).on('submit', 'form[data-ajax="true"]', function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    var form = $(this);
    submit_form(form);
    return false;
});


function executeFunctionByName(functionName, context, data) {

    if (typeof context=='undefined')
        context = window;

    var args = [].slice.call(arguments).splice(2);
    var namespaces = functionName.split(".");
    var func = namespaces.pop();
    for (var i = 0; i < namespaces.length; i++) {
        context = context[namespaces[i]];
    }
    if ($.isFunction(context[func])) {
        return context[func].apply(this, args);
    }
}


$(document).on('click', 'a[data-ajax=true]', function (e) {

    var link = $(this);
    var data_attr_ = getDataAttr(link);

    if (typeof data_attr_['start'] !== 'undefined') {
        executeFunctionByName(data_attr_['start'], window);
    }

    var link = $(this);
    var response_element = $(link.attr('data-response'));

    response_element.show();


    spinner(response_element);
    e.preventDefault();
    e.stopImmediatePropagation();

    var datatype = 'get';
    if (typeof data_attr_['type'] !== 'undefined' && (data_attr_['type'] == 'post')) {
        datatype = 'post';
    }

    $.ajax({

        type: datatype,
        url: link.attr('href'),
        contentType: false

    }).done(function (msg) {
        js_reload();
        process_response(msg, link, response_element);
        if (typeof data_attr_['callback'] !== 'undefined') {
            executeFunctionByName(data_attr_['callback'], window, msg);
        }

        if (msg.redirect !== undefined) {
            location.href = msg.redirect;
        }

        if (msg.message !== undefined) {
            $('.message').empty();
            $.each(msg.message, function (i, val) {
                $('.message').append(val);
            });
        }

    });

    return false;
});

function disable_form(form) {
    form.find(':input:not(:disabled)').prop('disabled', true);
}

function enable_form(form) {
    form.find(':input:disabled').prop('disabled', false);
}

$(document).ready(function () {


    $('label').each(function (i) {
        var id = $(this).attr('for'),
            input = $('input[name="' + id + '"]');
        if (typeof input.attr('placeholder') !== 'undefined' && input.attr('placeholder').trim().length > 0) return;
        input.attr('placeholder', $(this).text().trim().replace(':', ''));
    });

    $('.back > a').click(function () {
        window.history.back();
        return false;
    });

    $('.interval').each(function (e) {
        init_interval($(this));
    });

});

function init_interval(element) {

    var interval = setInterval(function () {

        var time = element.html().split(':').map(parseFloat);

        if (time[2] === 0) {

            if (time[1] === 0) {
                if (time[0] === 0) {
                    clearInterval(interval);
                    return;
                } else {
                    time[0]--;
                    time[1] = 59;
                }
            } else {
                time[1]--;
            }
            time[2] = 60;

        }

        time[2]--;

        element.html(time.map(function (n) {
            n = n + '';
            return n.length >= 2 ? n : new Array(2 - n.length + 1).join('0') + n;
        }).join(':'));

    }, 1000);
}



function close_modal($dark) {
    $('body').css('overflow', 'auto');
    $dark.removeClass('active');
    $dark.fadeOut();
}

function open_modal($dark) {
    $('body #confirm').remove();
    $('body').append($dark);
    $('body').css('overflow', 'hidden');
    $dark.fadeIn();
    $dark.addClass('active');
    return $dark;
}

function show_modal(id) {
    var $dark = $('#' + id);
    open_modal($dark);
    return $dark;
}

function hide_modal(id) {
    var $dark = $('#' + id);
    close_modal($dark);
}

function array_move(arr, old_index, new_index) {
    //Moure elements dins d'un array d'una posició a una altra
    if (new_index >= arr.length) {
        var k = new_index - arr.length + 1;
        while (k--) {
            arr.push(undefined);
        }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr; // for testing
};

$(window).on('keyup', function (e) {
    if (e.keyCode == 27) {
        var modals = $('.dark').filter(function () {
            return $(this).css('display') == 'block';
        });
        if (modals.length > 0) close_modal(modals);
    }
});

$('.modal, .modal .cancel').on('click keyup', function (e) {
    if (e.target == this) close_modal($(this).parents('.dark'));
});


$('#edit-admin').click(function (e) {
    e.preventDefault();
    var form = $(this).parent()[0],
        $form = $(form);
    select_socios(function (selected, numselected) {
            var data = $.merge($form.serializeArray(), selected);
            submit_form($form, data);
            //}, 1, parseInt(form.libres.value, 10) + parseInt(form.ocupados.value, 10),
        }, 1, 4,
        parseInt(form.nivel.value, 10),
        parseInt(form.id_reserva.value, 10));
});

function get_date(input) {
    if (input.trim() === '') return false;
    var parts = input.match(/(\d+)/g);
    return parts[2] + '/' + parts[1] + '/' + parts[0];
}

$('.timepicker').each(function () {

    var $this = $(this),
        allowed = $this.attr('data-allowed') || "",
        step = $this.attr('data-step') || 30,
        min = $this.attr('data-min') || false,
        max = $this.attr('data-max') || false,
        $duration = $('select[name="duration"]');
    var $end = $('input[name="time_fin"]');

    $this.datetimepicker({
        lang: 'ca',
        datepicker: false,
        format: 'H:i',
        allowTimes: allowed.length > 0 ? allowed.split(',') : undefined,
        step: step,
        mask: '__:__',
        maxTime: max,
        minTime: min,
        timepickerScrollbar: false,
    });

});

function inArray(needle, haystack) {
    if (haystack == undefined) return false;
    var length = haystack.length;
    for(var i = 0; i < length; i++) {
        if(haystack[i] == needle) return true;
    }
    return false;
}

function update_values() {
    var dur = $('select[name="duration"]').find(':selected').val();
    if (dur == undefined) { //No tenim un select/desplegable per triar duració reserva. La durada de la reserva no es pot modificar
        dur = $('input[name="duration"]')[0].value;
    }
    var time_min = $('input[name="time_min"]').val();
    var time_max = $('input[name="time_max"]').val();
    var time_ini_hueco = $('input[name="time_ini_hueco"]').val();
    var time_fin_hueco = $('input[name="time_fin_hueco"]').val();
    time_ini_hueco = time_ini_hueco.replace(/&quot;/g,'"');
    time_ini_hueco = JSON.parse(time_ini_hueco);
    time_fin_hueco = time_fin_hueco.replace(/&quot;/g,'"');
    time_fin_hueco = JSON.parse(time_fin_hueco);

    var ini = $("select[name='time_ini'] option");
    if (ini.length == 0){
        var option_hora_ini = $('input[name="time_ini"]').val().split(':');
        var ini = new moment(time_min);
        ini.startOf('day');
        ini.set('hour', option_hora_ini[0]);
        ini.set('minute', option_hora_ini[1]);
        ini.add(dur, 'minutes');
        var duration_minutes = ini.get('minutes').toString().length == 1 ? '0' + ini.get('minutes') : ini.get('minutes');
        var time_fin = ini.get('hours') + ':' + duration_minutes;
        var text = Lang.get('msg.de_') + ' ' + $('input[name="time_ini"]').val() + ' ' + Lang.get('msg._fins_a') + ' ' + time_fin;
        $("#noPuedeCambiar").html(text);
    }
    else {
        var seleccionat = true;
        $("select[name='time_ini'] option").each(function (k, o) {
            var option_hora_ini = $(o).val().split(':');
            var ini = new moment(time_min);
            ini.startOf('day');
            ini.set('hour', option_hora_ini[0]);
            ini.set('minute', option_hora_ini[1]);
            var time_ini_o = new moment(ini);
            ini.add(dur, 'minutes');
            var time_fin_o = new moment(ini);

            var duration_minutes = ini.get('minutes').toString().length == 1 ? '0' + ini.get('minutes') : ini.get('minutes');
            var time_fin = ini.get('hours') + ':' + duration_minutes;

            var text = $(o).data('text_from') + ' ' + $(o).val() + ' ' + $(o).data('text_to') + ' ' + time_fin;

            time_ini_o = time_ini_o.format('YYYY-MM-DD HH:mm:ss');
            time_fin_o = time_fin_o.format('YYYY-MM-DD HH:mm:ss');

            if ((time_max < time_fin_o) || (inArray(time_fin_o, time_fin_hueco[dur]))){
                $(o).prop('disabled', true);
                $(o).addClass('danger');
                if ( $(o).prop('selected') ){
                    seleccionat = false;
                }
            } else {
                if ((time_min >= time_ini_o) || (inArray(time_ini_o, time_ini_hueco[dur]))) {
                    $(o).prop('disabled', true);
                    $(o).addClass('danger');
                    if ( $(o).prop('selected') ){
                        seleccionat = false;
                    }
                } else {
                    $(o).removeAttr('disabled');
                    $(o).removeClass('danger');
                }
            }

            $(o).html(text);
        });
        if (seleccionat === false){
            // seleccionem l'últim vàlid
            $("select[name='time_ini'] option").each(function (k, o) {

                if ( !($(o).prop('disabled')) ) {
                    $(o).prop('selected', true);
                }

                $(o).html(text);
            });
        }
    }


}

function changeDurationOrTimeIni(){
    update_values();
}

$(document).on('change','select[name="duration"]',function(){
        changeDurationOrTimeIni();
});


function datetimepicker_() {
    $('.datetimepicker').each(function () {
        var $cal = $(this);
        $cal.datetimepicker({
            lang: 'ca',
            dayOfWeekStart: 1,
            format: 'd/m/Y H:i',
            defaultTime: '08:00',
            onShow: function (dt) {
                var sel = null;
                if ($cal.attr('data-max')) {
                    sel = $cal.attr('data-max');
                    this.setOptions({
                        maxDate: get_date($(sel).val())
                    });
                }
                if ($cal.attr('data-min')) {
                    sel = $cal.attr('data-min');
                    this.setOptions({
                        minDate: get_date($(sel).val())
                    });
                }
                if ($cal.attr('data-min-today') === 'true') {
                    this.setOptions({
                        minDate: 0
                    });
                }
            }
        });
    });

    $('.datepicker').each(function () {
        var $cal = $(this);
        $cal.datetimepicker({
            lang: 'ca',
            dayOfWeekStart: 1,
            format: 'd/m/Y',
            defaultDate: $cal.data('defaultdate'),
            timepicker: false,
            onShow: function (dt) {
                var sel = null;
                if ($cal.attr('data-max')) {
                    sel = $cal.attr('data-max');
                    this.setOptions({
                        maxDate: get_date($(sel).val())
                    });
                }
                if ($cal.attr('data-min')) {
                    sel = $cal.attr('data-min');
                    this.setOptions({
                        minDate: get_date($(sel).val())
                    });
                }
            }
        });
    });


}

$(window).on('load', function (e) {
    js_reload();
});

function sortable_(){
    $(".sortable").sortable({
        placeholder: "ui-state-highlight",
        handle: '.handler',
        cancel: ''
    }).disableSelection();
}

function js_reload() {

    datetimepicker_();
    $('[data-toggle="tooltip"]').tooltip({
        container: 'body'
    });
    $("[data-toggle=popover]").each(function(i, obj) {
        $(this).popover({
        });
    });
    $(".checkbox:not(.ind)").each(function (e) {
        $(this).bootstrapSwitch('state');
    });
    loading(0);

    sortable_();
}

function validate_form(formClass) {
    var error = 0;
    $(formClass).find('input:required').each(function () {
        var input = $(this);
        $(input).closest('.form-group').removeClass('has-error');

        if (input.val() == '') {
            $(input).closest('.form-group').addClass('has-error');
            if (error == 0) {
                $(input).focus();
            }
            error = 1;
        }

    });
    if (error == 1) {
        alert(Lang.get('msg.falten_omplir_dades'));
        return false
    }
    return true;
}

function clearForm(form) {
    var frm_elements = form.elements;

    for (var i = 0; i < frm_elements.length; i++) {
        var field_type = frm_elements[i].type.toLowerCase();
        switch (field_type) {
            case "text":
            case "password":
            case "textarea":
            case "hidden":
                frm_elements[i].value = "";
                break;
            case "radio":
            case "checkbox":
                if (frm_elements[i].checked) {
                    frm_elements[i].checked = false;
                }
                break;
            case "select-one":
            case "select-multi":
                frm_elements[i].selectedIndex = 0;
                break;
            default:
                break;
        }
    }
}

if (typeof Stripe != 'undefined') {

    Stripe.setPublishableKey(stripe_public_key);

    $('#pay-event').on('click', function (e) {

        var $this = $(this),
            preu = $this.attr('data-preu'),
            email = $this.attr('data-email'),
            desc = $this.attr('data-tarifa-desc');

        show_modal('payment');

    });

    $('#frm-payment').on('submit', function (e) {


        e.preventDefault();
        e.stopImmediatePropagation();

        var $form = $(this),
            $response = $form.find('.response');

        disable_form($form);
        hover_spinner($form);
        var number = $form.find('[name="num[]"]').map(function () {
            return this.value;
        }).get().join('');

        Stripe.card.createToken({
            number: number,
            cvc: $form.get(0).secret.value,
            exp_month: $form.get(0).month.value,
            exp_year: $form.get(0).year.value,
            name: $form.get(0).nombre.value
        }, stripeResponseHandler);

        function stripeResponseHandler(status, response) {
            if (response.error) {
                process_response({
                    status: 'error',
                    data: {
                        msg: t(response.error.code)
                    }
                }, $form, $response);
                enable_form($form);
                stop_hover_spinner($form);
            } else {
                process_response({
                    status: 'ok',
                    data: {msg: t('processing payment')}
                }, $form, $response);
                setTimeout(function () {
                    hide_modal('payment');
                    $('#reserva-token').val(response.id);
                    submit_form($('#event-form'));
                    enable_form($form);
                    stop_hover_spinner($form);
                    clearForm($form.get(0));
                }, 1000);
            }
        }

    });

}

function confirmDialog(text,options) {

    var cb = {
        yes: null,
        no: null
    };

    var $confirm = $(
        '<div class="dark" id="confirm">' +
        '   <div class="modal-top">' +
        '        <div class="modal" >' +
        '           <div class="modal-inner" >' +
        '               <div class="modal-content" style="padding:5px; ">' +
        '                   <p class="caption"></p>' +
        '                   <button class="btn btn-ok">'+Lang.get('msg.Aceptar')+'</button>' +
        '                   <button class="btn btn-danger">'+Lang.get('compra.cancel')+'</button>' +
        '               </div>' +
        '           </div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
        );//$('#confirm');

    $confirm.find('.caption').html(text);
        var $yes = $confirm.find('.btn.btn-ok');
        var $no = $confirm.find('.btn.btn-danger');

    open_modal($confirm);

    $yes.off('click');
    $no.off('click');

    if (typeof options!=='undefined'){
        if (typeof options.yes!=='undefined'){
            if (options.yes==false)
                $yes.addClass('hidden');
        }
    }

    $yes.on('click', function () {
        close_modal($confirm);
        if (cb.yes) cb.yes();
    });

    $no.on('click', function () {
        close_modal($confirm);
        if (cb.no) cb.no();
    });

    return {
        yes: function (fn) {
            cb.yes = fn;
        },
        no: function (fn) {
            cb.no = fn;
        }
    };

}

$('.request-code').on('submit', function (e) {
    e.preventDefault();
    var $this = $(this);
    confirmDialog(t('request code warning'))
        .yes(function () {
            submit_form($this);
        });
});


$('.tab-control .tab-list li').on('click', function () {
    var $ctrl = $(this).closest('.tab-control');
    $ctrl.find('.tab').hide();
    $ctrl.find('.tab[data-tab="' + $(this).attr('data-tab') + '"]').show();
    $ctrl.find('.tab-list li.active').removeClass('active');
    $(this).addClass('active');
});


$('.tab-control .tab').hide();
$('.tab-control .tab-list li:first-child').click();

$('input[maxlength][data-input-group]').on('keydown', function (e) {
    var $this = $(this),
        maxlength = $this.attr('maxlength');
    if ((e.which == 46 || e.which == 8) && $this.val().length === 0) {
        var id = $this.attr('data-input-group');
        var $prev = $this.prev('input[data-input-group="' + id + '"]');
        $prev.focus();
    } else if ($this.val().trim().length >= maxlength) {
        var id = $this.attr('data-input-group');
        var $next = $this.next('input[data-input-group="' + id + '"]');
        $next.focus();
    }
});


$('select[data-parent]').each(function () {
    var $this = $(this);
    var $form = $this.closest('form');
    var $parent = $('[name="' + $this.attr('data-parent') + '"]');
    $parent.on('change', function () {
        $this.html('');
        hover_spinner($form);
        var data = {
            op: $this.attr('data-op'),
        };
        data[$this.attr('data-parent')] = this.value;
        $.ajax({
            url: '../sportssuite/manager.php',
            data: data
        })
            .always(function () {
                stop_hover_spinner($form);
            })
            .done(function (res) {
                if (res && res.status == 'ok') {
                    $this.prop('disabled', res.data.length === 0 || res.data.length === 1 && res.data[0].id === 0);
                    res.data.forEach(function (v) {
                        var $opt = $('<option />').appendTo($this);
                        $opt.html(v.caption);
                        $opt.attr('value', v.id);
                    });
                }
            });
    });
    $parent.change();
});

$('[data-page]').on('click', function (e) {
    e.preventDefault();
    url.page = $(this).attr('data-page');
    url._set();
});


$('#delete_event').on('click', function (e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    if ($("#eliminarReservaPermiso").val()=='0'){
        confirmDialog(Lang.get('reserva.EliminaReservaNoPermitirFacturaoficialMsg1'),{yes:false})
            .yes(function () {
                submit_form($form);
            });
        return;
    }

    confirmDialog(Lang.get('reserva.Eliminar_reserva_alerta'))
        .yes(function () {
            submit_form($form);
        });
});

$('.btn-delete-row').on('click', function (e) {
    e.preventDefault();
    var $link = $(this);
    var response_element = $($link.attr('data-response'));
    var $row = $link.closest('tr');

    e.preventDefault();
    e.stopImmediatePropagation();

    confirmDialog(t('delete queue warning'))
        .yes(function () {
            response_element.show();
            spinner(response_element);
            $.ajax({
                type: 'get',
                url: $link.attr('href'),
                contentType: false,
            }).done(function (msg) {
                process_response(msg, $link, response_element);
                if (msg && msg.status == 'ok') {
                    $row.fadeOut("normal", function () {
                        $(this).remove();
                    });
                }
            });
        });
});

$('select').on('change', function () {
    var $this = $(this);
    var $new = $this.siblings('.new-item');
    if ($new.length > 0) {
        $new.toggle($this.val() === '+');
    }
});

$('.new-item').hide();
$('.new-item').siblings('select').trigger('change');


function loading(state) {
    var loading = $("#loading");

    if (state !== 0) {
        if (loading.css('display') === 'block') {

            loading.fadeOut('fast');
        } else {
            loading.fadeIn('fast');         
        }
    } else {
        loading.fadeOut('fast');
    }
}
$('.modal').on('show.bs.modal', function () {

    setTimeout(function () {
        var scrollLocation = $(window).scrollTop();
        $('.modal')
            .addClass('modal-ios')
            .height($(window).height())
            .css({'margin-top': 0 + 'px'});


    }, 0);
});


function preparaIosModal(){
    setTimeout(function () {
        var scrollLocation = $(window).scrollTop();
        $('.modal')
            .addClass('modal-ios')
            .height($(window).height())
            .css({'margin-top': 0 + 'px'});
        $('.modal .table-responsive').height($(window).height()-200);
    }, 100);
}

if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {

    $('.modal').on('show.bs.modal', function () {
        preparaIosModal();
    });

    $('input').on('blur', function () {
        setTimeout(function () {
            // This causes iOS to refresh, fixes problems when virtual keyboard closes
            $(window).scrollLeft(0);

            var $focused = $(':focus');
            // Needed in case user clicks directly from one input to another
            if (!$focused.is('input')) {
                // Otherwise reset the scoll to the top of the modal
                $(window).scrollTop(scrollLocation);
            }
        }, 0);
    })

}

function modal_c(content) {
    $("#modal_c").remove();
    $(".modal-backdrop").remove();


    if (typeof(content) === 'object') {
        //title:'title',
        //    text: data,
        //    size:'lg',
        //    button: {close: 'Tancar'}

        var size = '';
        if (typeof(content.size !== 'undefined')) {
            size = 'modal-' + content.size;
        }


        var contingut_modal = '' +
            '<div class="modal-dialog ' + size + '">' +
            '   <div class="modal-content">' +
            '       <div class="modal-header">' +
            '           <button type="button" class="close" data-dismiss="modal">&times;</button>' +
            '           <h4 class="modal-title">' + content.title + '</h4>' +
            '       </div>' +
            '       <div class="modal-body">' +
            '           <p>' + content.text + '</p>' +
            '       </div>' +
            '       <div class="modal-footer">' +
            '           <button type="button" class="btn btn-default" data-dismiss="modal">' + content.button.close + '</button>';

        if(content.button.forzarefectivo !==undefined && content.button.forzarefectivo !=='undefined'){
            contingut_modal = contingut_modal +
                '           <button type="button" class="btn btn-default" data-dismiss="modal" onclick="ok_apretat()">' + content.button.ok + '</button>';
        }
        contingut_modal = contingut_modal +
            '       </div>' +
            '   </div>' +
            '</div>';

        $('body').append($('<div id="modal_c" class="modal_c modal  fade">' + contingut_modal + '</div>'));

        if (typeof(content.timeout_reload) !== 'undefined') {
            setTimeout(function () {
                location.reload()
            }, 3000);
        }

    } else {
        $('body').append($('<div id="modal_c" class="modal_c modal fade">' + content + '</div>'));
    }


    $("#modal_c").modal({backdrop: 'static'}, 'show');

    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        preparaIosModal();
    }


}

function modal_c2(content) {
    $("#modal_c").remove();
    $(".modal-backdrop").remove();


    if (typeof(content) === 'object') {
        //title:'title',
        //    text: data,
        //    size:'lg',
        //    button: {close: 'Tancar'}

        var size = '';
        if (typeof(content.size !== 'undefined')) {
            size = 'modal-' + content.size;
        }


        var contingut_modal = '' +
            '<div class="modal-dialog ' + size + '">' +
            '   <div class="modal-content">' +
            '       <div class="modal-header">' +
            '           <h4 class="modal-title">' + content.title + '</h4>' +
            '       </div>' +
            '       <div class="modal-body">' +
            '           <p>' + content.text + '</p>' +
            '       </div>' +
            '       <div class="modal-footer">';

        if(content.button.forzarefectivo !==undefined && content.button.forzarefectivo !=='undefined'){
            contingut_modal = contingut_modal +
                '           <button type="button" class="btn btn-default" data-dismiss="modal" onclick="ok_apretat()">' + content.button.ok + '</button>';
        }
        contingut_modal = contingut_modal +
            '       </div>' +
            '   </div>' +
            '</div>';

        $('body').append($('<div id="modal_c" class="modal_c modal  fade">' + contingut_modal + '</div>'));

        if (typeof(content.timeout_reload) !== 'undefined') {
            setTimeout(function () {
                location.reload()
            }, 3000);
        }

    } else {
        $('body').append($('<div id="modal_c" class="modal_c modal fade">' + content + '</div>'));
    }


    $("#modal_c").modal({backdrop: 'static'}, 'show');

    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        preparaIosModal();
    }


}


$(function () {

    $.ajaxSetup({
        headers: {
            'X-CSRF-Token': $('meta[name="csrf_token"]').attr('content')
        }
    });

    $('[data-toggle="tooltip"]').tooltip({
        container: 'body'
    });


    $(".navbar-toggle").click(function () {
        $("#sidebar-wrapper").toggleClass('collapsed', 400);
    });
    $("#sidebar-wrapper .closeBtn").click(function () {
        $("#sidebar-wrapper").toggleClass('collapsed', 400);
    });

    /*Funció per duplicar continguts del web.
     * Es necessita:
     *
     * 1. DIV original. Amb classe .origin & .duplicate. Amb data-destiny="--classe DIV destí--"
     *
     * Ex: <div data-destiny="setmana-buttons" class="origin duplicate">--CONTINGUT--</div>
     *
     * 2. DIV destí. Amb classe .destiny i una segona classe que ha d'anar en concordància amb el data-destiny del DIV orígen
     *
     * Ex: <div class="setmana-buttons destiny"></div>
     *
     * */
    $(".duplicate.origin").each(function () {
        var this_ = $(this);
        $("." + this_.data('destiny') + '.destiny').html(this_.html());
    })

    $(".notificacionUsuarioVisto").click(function () {
        var boton = $(this);
        var contenedor = $(boton).closest(".notificacionUsuarioContainer");
        if ($("#verTodasBtn").hasClass('disabled')) {
            //Estamos viendo todas
            contenedor.addClass('vista');
        } else {
            contenedor.hide('100');
        }

        $.post('api/notificacionesVisto', {'id_reg_notificacionusuario': $(boton).data('id_reg_notificacionusuario')},function(res){
            var badge = $(".menu-notificaciones .badge");
            if (res.numero_notificaciones>0){
                badge.html(res.numero_notificaciones);
            }else{
                badge.addClass('hidden');
            }
        });
    });

    $("#notificacionMarcarComoLeidosBtn").click(function (e) {
        e.preventDefault();
        $.post('api/notificacionesMarcarComoLeidos', {}, function () {
            if ($("#verTodasBtn").hasClass('disabled')) {
                //Estamos viendo todas
                $(".notificacionUsuarioContainer").addClass('vista');
            } else {
                $(".notificacionUsuarioContainer").hide(100);
            }

        });
    });


    var autosubscribe = getParameterByName('autosubscribe');
    if (autosubscribe == 1) {
        submit_form($("#event-form-subscribe"));
    }

    cal_usermanager_mostrar_recursos_notificaciones_automaticas();






    /*Cal_user, en nuevo usuario y actuales, mostrar horarios de notificacion*/

    var newUser = false;
    if ($(".cal_new_user").length > 0)
        newUser = true;
    var options = {
        valueNames: ['id', 'start', 'end'],
    };

    $('#trams .tab').each(function () {

        var tramsList = new List($(this).find('.trams')[0], options);
        var $this = $(this);
        var idField = $this.find('.tram-id'),
            startField = $this.find('.tram-start'),
            endField = $this.find('.tram-end'),
            addBtn = $this.find('.add-btn'),
            editBtn = $this.find('.edit-btn').hide(),
            removeBtns = $this.find('.remove-tram'),
            editBtns = $this.find('.edit-tram'),
            tipoDia = $this.attr('data-tab');

        refreshCallbacks();

        addBtn.click(function (e) {
            e.preventDefault();
            if (newUser == false) {
                $.ajax({
                    type: 'POST',
                    url: '/api/socio/notificacion/addNotificationRange',
                    data: {
                        start: startField.val(),
                        finish: endField.val(),
                        tipodia: tipoDia
                    },
                    success: function (data) {
                        var status = process_response(data, $this.find('.add-edit-controls'), $this.find('.add-edit-controls-response'), true);
                        if (status === 'ok') {
                            tramsList.add({
                                id: data.data.id,
                                start: startField.val(),
                                end: endField.val()
                            });
                            refreshCallbacks();
                        }
                    }
                });
            } else {
                tramsList.add({
                    id: Math.floor((Math.random() * 99999999) + 1),
                    start: startField.val(),
                    end: endField.val(),
                });
                refreshCallbacks();
            }


        });

        editBtn.click(function (e) {
            var item = tramsList.get('id', idField.val())[0];
            if (newUser == false) {
                $.ajax({
                    type: 'POST',
                    url: '/api/socio/notificacion/modNotificationRange',
                    data: {
                        id: idField.val(),
                        start: startField.val(),
                        finish: endField.val()
                    },
                    success: function (data) {
                        //var status = process_response(data, $('#add-edit-controls'), $('#add-edit-controls-response'), true);
                        if (data.status === 'ok') {
                            item.values({
                                id: idField.val(),
                                start: startField.val(),
                                end: endField.val()
                            });
                            editBtn.hide();
                            addBtn.show();
                        }
                    }
                });
            } else {
                item.values({
                    id: idField.val(),
                    start: startField.val(),
                    end: endField.val()
                });
                editBtn.hide();
                addBtn.show();
            }
        });

        function refreshCallbacks() {

            editBtns.on('click', function (e) {
                e.preventDefault();
                var itemId = $(this).closest('tr').find('.id').text(),
                    itemValues = tramsList.get('id', itemId)[0].values();
                idField.val(itemValues.id);
                startField.val(itemValues.start);
                endField.val(itemValues.end);
                editBtn.show();
                addBtn.hide();
            });
        }

        function refreshCallbacks() {

            removeBtns.off('click');
            editBtns.off('click');

            removeBtns = $this.find(removeBtns.selector);
            editBtns = $this.find(editBtns.selector);

            removeBtns.on('click', function (e) {
                var itemId = $(this).closest('tr').find('.id').text();
                e.preventDefault();
                if (newUser == false) {
                    $.ajax({
                        type: 'POST',
                        url: '/api/socio/notificacion/delNotificationRange',
                        data: {
                            id: itemId
                        },
                        success: function (data) {
                            if (data.status === 'ok')
                                tramsList.remove('id', itemId);
                        }
                    });
                } else {
                    tramsList.remove('id', itemId);
                }
            });

            editBtns.on('click', function (e) {
                e.preventDefault();
                var itemId = $(this).closest('tr').find('.id').text(),
                    itemValues = (tramsList.get('id', itemId)[0]).values();
                itemValues = tramsList.get('id', itemId)[0].values();
                idField.val(itemValues.id);
                startField.val(itemValues.start);
                endField.val(itemValues.end);
                editBtn.show();
                addBtn.hide();
            });
        }


    });

    /*Cal_user, en nuevo usuario y actuales, mostrar horarios de notificacion*/

    expiraSesion();

});




function avisar(reserva) {
    $.ajax({
        type: 'GET',
        url: '../sportssuite/manager.php',
        data: {
            op: 'add_avis',
            id: reserva

        }
    }).done(function (response) {
        if (response && response.status == "ok") {
            alert(response.data.msg);
            //response.data
        } else {
            alert(response.data.msg);
        }
    });

}
$(document).on('click', '[data-load-modal="true"]', function (e) {

    e.preventDefault();
    var url = $(this).attr('href');
    var element = $(this);
    if (url.indexOf('#') == 0) {        
        $(url).modal('open');
    } else {
        
        $.get(url)
            .done(function (data, textStatus, jqXHR) {
                if (jqXHR.status === 200) {
                      $("#loading").fadeOut('fast');
                    modal_c(data);

                    var data_attr_ = getDataAttr(element);

                    if (typeof data_attr_['callback'] !== 'undefined') {
                        executeFunctionByName(data_attr_['callback'], window);
                    }                      
                  

                    js_reload();
                }
            })
            .fail(function (jqXHR, textStatus, errorThrown) {
                console.error("Error carregant modal:", textStatus, errorThrown);
                $("#loading").fadeOut('fast');
            });
    }
    return false;
});


$(document).on('click', 'a:not(.noload)', function (e) {

    //Realizamos controles para no ejecutar loading() en algunos casos

    if ($(this).closest('.dropdown').hasClass('v-select'))
        return;

    var loading_ = 1; //per defecte mostrem el loading a no ser que sigui un enllaç intern (conté #), un anchor que no té href, o bé un anchor que s'obre en un altre pàgina (target="_blank")

    if (typeof $(this).attr('href') !== 'undefined' && $(this).attr('href') !== false) { //Enllaç normal amb un HREF definit
        if (($(this).attr('href')).slice(0, 1) == '#') {
            loading_ = 0;
        }
        if( $(this).attr('target') == "_blank")
        {
            loading_ = 0;
        }
    }
    else{ //NO és un enllaç normal amb un HREF definit
        loading_ = 0;
    }
    if (navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        //16/06/20. Amb dispositius iOS NO mostrem mai el LOADING (perquè no funciona bé el codi que el fa desaparèixer i després la pantalla queda a davant) i bloqueja tota la web/app
        loading_ = 0;
    }

    if (loading_ === 1) {
        loading();
    }

});

$(window).load(function () {
    $("#loading_spin").fadeOut(200);
});

var $sel_modalidad = $('select[name="modalidad"]');
var lastSel = $("#sel_modalidad option:selected");
$("#sel_modalidad").click(function(){
    lastSel = $("#sel_modalidad option:selected");
});
$sel_modalidad.on('change', function () {
    var $this = $(this);
    var socisList = document.getElementById("socis-list");
    var nodes = socisList.getElementsByTagName("li");
    var numSlotsActual = nodes.length;
    var slotsLliures = socisList.getElementsByClassName("afegir_soci_btn").length;

    var numFaltan;
    numFaltan = $this.val() - (numSlotsActual - slotsLliures);

    if(numSlotsActual < $this.val()){
        document.getElementById("libres_range").max = numFaltan;
        document.getElementById("libres_range").value = numFaltan;
        document.getElementById("libres_value").value = numFaltan;
        document.getElementById("libres_value_show").value = numFaltan;
        slots(); //Afegim slots/particpants que falten
    }
    else if(numSlotsActual - slotsLliures > $this.val()){
        alert(Lang.get('reserva.eliminaParticipantsManual'));
        lastSel.prop("selected", true); //recuperem valor seleccionat anteriorment. Cancel·lem canvi
        return false;
    }
    else if(numSlotsActual - slotsLliures <= $this.val()){
        document.getElementById("libres_range").max = numFaltan;
        document.getElementById("libres_range").value = numFaltan;
        document.getElementById("libres_value").value = numFaltan;
        document.getElementById("libres_value_show").value = numFaltan;
        slots(); //Eliminem slots lliures que sobren
    }
});

var $sel_tiporeserva = $('select[name="sel_tiporeserva"]');

$sel_tiporeserva.on('change', function () {
    var $this = $(this);
    setGetParameter('tiporeserva', $this.val());
});

function setGetParameter(paramName, paramValue) {
    var url = window.location.href;
    //var hash = location.hash;
    //url = url.replace(hash, '');
    if (url.indexOf(paramName + "=") >= 0) {
        var prefix = url.substring(0, url.indexOf(paramName));
        var suffix = url.substring(url.indexOf(paramName));
        suffix = suffix.substring(suffix.indexOf("=") + 1);
        suffix = (suffix.indexOf("&") >= 0) ? suffix.substring(suffix.indexOf("&")) : "";
        url = prefix + paramName + "=" + paramValue + suffix;
    }
    else {
        if (url.indexOf("?") < 0)
            url += "?" + paramName + "=" + paramValue;
        else
            url += "&" + paramName + "=" + paramValue;
    }
    window.location.href = url; // + hash;
}


function getParameterByName(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function removeDiacritics(str) {

    if (str == null)
        return;


    var defaultDiacriticsRemovalMap = [
        {
            'base': 'A',
            'letters': /[\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F]/g
        },
        {'base': 'AA', 'letters': /[\uA732]/g},
        {'base': 'AE', 'letters': /[\u00C6\u01FC\u01E2]/g},
        {'base': 'AO', 'letters': /[\uA734]/g},
        {'base': 'AU', 'letters': /[\uA736]/g},
        {'base': 'AV', 'letters': /[\uA738\uA73A]/g},
        {'base': 'AY', 'letters': /[\uA73C]/g},
        {'base': 'B', 'letters': /[\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181]/g},
        {'base': 'C', 'letters': /[\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E]/g},
        {
            'base': 'D',
            'letters': /[\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779]/g
        },
        {'base': 'DZ', 'letters': /[\u01F1\u01C4]/g},
        {'base': 'Dz', 'letters': /[\u01F2\u01C5]/g},
        {
            'base': 'E',
            'letters': /[\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E]/g
        },
        {'base': 'F', 'letters': /[\u0046\u24BB\uFF26\u1E1E\u0191\uA77B]/g},
        {
            'base': 'G',
            'letters': /[\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E]/g
        },
        {
            'base': 'H',
            'letters': /[\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D]/g
        },
        {
            'base': 'I',
            'letters': /[\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197]/g
        },
        {'base': 'J', 'letters': /[\u004A\u24BF\uFF2A\u0134\u0248]/g},
        {
            'base': 'K',
            'letters': /[\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2]/g
        },
        {
            'base': 'L',
            'letters': /[\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780]/g
        },
        {'base': 'LJ', 'letters': /[\u01C7]/g},
        {'base': 'Lj', 'letters': /[\u01C8]/g},
        {'base': 'M', 'letters': /[\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C]/g},
        {
            'base': 'N',
            'letters': /[\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4]/g
        },
        {'base': 'NJ', 'letters': /[\u01CA]/g},
        {'base': 'Nj', 'letters': /[\u01CB]/g},
        {
            'base': 'O',
            'letters': /[\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C]/g
        },
        {'base': 'OI', 'letters': /[\u01A2]/g},
        {'base': 'OO', 'letters': /[\uA74E]/g},
        {'base': 'OU', 'letters': /[\u0222]/g},
        {'base': 'P', 'letters': /[\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754]/g},
        {'base': 'Q', 'letters': /[\u0051\u24C6\uFF31\uA756\uA758\u024A]/g},
        {
            'base': 'R',
            'letters': /[\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782]/g
        },
        {
            'base': 'S',
            'letters': /[\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784]/g
        },
        {
            'base': 'T',
            'letters': /[\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786]/g
        },
        {'base': 'TZ', 'letters': /[\uA728]/g},
        {
            'base': 'U',
            'letters': /[\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244]/g
        },
        {'base': 'V', 'letters': /[\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245]/g},
        {'base': 'VY', 'letters': /[\uA760]/g},
        {'base': 'W', 'letters': /[\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72]/g},
        {'base': 'X', 'letters': /[\u0058\u24CD\uFF38\u1E8A\u1E8C]/g},
        {
            'base': 'Y',
            'letters': /[\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE]/g
        },
        {
            'base': 'Z',
            'letters': /[\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762]/g
        },
        {
            'base': 'a',
            'letters': /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/g
        },
        {'base': 'aa', 'letters': /[\uA733]/g},
        {'base': 'ae', 'letters': /[\u00E6\u01FD\u01E3]/g},
        {'base': 'ao', 'letters': /[\uA735]/g},
        {'base': 'au', 'letters': /[\uA737]/g},
        {'base': 'av', 'letters': /[\uA739\uA73B]/g},
        {'base': 'ay', 'letters': /[\uA73D]/g},
        {'base': 'b', 'letters': /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/g},
        {'base': 'c', 'letters': /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/g},
        {
            'base': 'd',
            'letters': /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/g
        },
        {'base': 'dz', 'letters': /[\u01F3\u01C6]/g},
        {
            'base': 'e',
            'letters': /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/g
        },
        {'base': 'f', 'letters': /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/g},
        {
            'base': 'g',
            'letters': /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/g
        },
        {
            'base': 'h',
            'letters': /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/g
        },
        {'base': 'hv', 'letters': /[\u0195]/g},
        {
            'base': 'i',
            'letters': /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/g
        },
        {'base': 'j', 'letters': /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/g},
        {
            'base': 'k',
            'letters': /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/g
        },
        {
            'base': 'l',
            'letters': /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/g
        },
        {'base': 'lj', 'letters': /[\u01C9]/g},
        {'base': 'm', 'letters': /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/g},
        {
            'base': 'n',
            'letters': /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/g
        },
        {'base': 'nj', 'letters': /[\u01CC]/g},
        {
            'base': 'o',
            'letters': /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/g
        },
        {'base': 'oi', 'letters': /[\u01A3]/g},
        {'base': 'ou', 'letters': /[\u0223]/g},
        {'base': 'oo', 'letters': /[\uA74F]/g},
        {'base': 'p', 'letters': /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/g},
        {'base': 'q', 'letters': /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/g},
        {
            'base': 'r',
            'letters': /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/g
        },
        {
            'base': 's',
            'letters': /[\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/g
        },
        {
            'base': 't',
            'letters': /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/g
        },
        {'base': 'tz', 'letters': /[\uA729]/g},
        {
            'base': 'u',
            'letters': /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/g
        },
        {'base': 'v', 'letters': /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/g},
        {'base': 'vy', 'letters': /[\uA761]/g},
        {'base': 'w', 'letters': /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/g},
        {'base': 'x', 'letters': /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/g},
        {
            'base': 'y',
            'letters': /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/g
        },
        {
            'base': 'z',
            'letters': /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/g
        }
    ];

    for (var i = 0; i < defaultDiacriticsRemovalMap.length; i++) {
        str = str.replace(defaultDiacriticsRemovalMap[i].letters, defaultDiacriticsRemovalMap[i].base);
    }

    return str;

}


$(document).on('click', ".list-group-item.equipo .btn", function () {

    var id_reg_campeonatos_grupo = $(this).closest('.inscripcio-equip-existent').data('id_reg_campeonatos_grupo');
    var equipos_sel = $(this).closest('.inscripcio-equip-existent').find('.equipos_sel');

    $(this).attr("disabled", true);

    var id_reg_equipos = $(this).attr("data-id_reg_equipos");
    var input = "<input type='hidden' name='equips[][id_reg_equipos]' value='" + id_reg_equipos + "'>";
    var equipo = $(this).attr("data-equipo");
    var button = "<span class='col-sm-4'><button class='btn btn-danger'>" + Lang.get('msg.delete') + "</button></span>";

    $('<li class="list-group-item equipo_sel" data-id_reg_equipos="' + id_reg_equipos + '">').appendTo(equipos_sel).html("<div class='row'>" + input + "<span class='col-sm-8'>" + equipo + "</span>" + button + "</div>");
    check_equipos_sel(id_reg_campeonatos_grupo);

    $(".list-group-item.equipo_sel .btn").click(function () {
        $(this).closest(".list-group-item.equipo_sel").remove();
        check_equipos_sel(id_reg_campeonatos_grupo);
    });
});

$('#notifyAndNotifyAppCheckboxes .checkbox').on('switchChange.bootstrapSwitch', function (event, state) {
    cal_usermanager_mostrar_recursos_notificaciones_automaticas();
});


function cal_usermanager_mostrar_recursos_notificaciones_automaticas() {
    var length = $("#notifyAndNotifyAppCheckboxes .checkbox:checked").length;
    if (length > 0) {
        $("#notifyAndNotifyAppTipoRecursos").slideDown('300');
        $("#notifyIntervals").slideDown('300');
    } else {
        $("#notifyAndNotifyAppTipoRecursos").slideUp('200');
        $("#notifyIntervals").slideUp('300');
    }
}

function eliminatoriaNumeroRondas(nEquipos) {
    var i = 1;
    for (var j = nEquipos; j > 1;) {
        j = j / 2;
        i++;
    }
    i--;
    return i;
}

function eliminatoriaRankingPuntosNombrarRondas(container) {

    var nrondas = $(container).find(".adminEliminatoriaRankingPuntosRonda .ronda").length;
    var textoRondas = [];
    var i = 0;
    var rondasIncremento = 4; //Es el valor que aparecerá como parcial (Ej: 1/4, 1/8, 1/16)
    for (var j = nrondas; j > 0;) {
        if (i == 0) {
            textoRondas.push(Lang.get('campeonato.Ganador'));
        } else if (i == 1) {
            textoRondas.push('Final');
        } else if (i==2){
            textoRondas.push('Semifinal');
        }else {
            textoRondas.push('1/' + rondasIncremento);
            rondasIncremento = rondasIncremento * 2;
        }
        j--;
        i++;
    }

    textoRondas.reverse();

    $(container).find(".adminEliminatoriaRankingPuntosRonda .ronda").each(function (key, value) {
        var ronda = $(this);
        ronda.find('.numRonda').html(textoRondas[key]);
        if(key+1==nrondas){
            ronda.prepend('<br/><div class="col-xs-12">'+Lang.get('campeonato.PuntosGanador')+':</div>');
        }
    });
}



function preparaNotificacionTramosEnvio() {
    //Al crear un nuevo usuario, prepara los input type hidden necesarios para enviar los tramos horarios
    $("#notifyIntervals #trams .tab").each(function () {
        var tab = $(this);
        tab.find('.notificacionTramosEnvio').remove();

        var tramos = [];
        tab.find('.list tr').each(function(){
            var tr = $(this);
            tramos.push({
                'start':tr.find('.start').html(),
                'end':tr.find('.end').html(),
            });
        });

        var notificacionTramosEnvio = $("<div class='notificacionTramosEnvio'/>");
        $.each(tramos, function( index, value ) {
            var inputHidden = '' +
                '<input type="hidden" name="notificacionTramosEnvio['+tab.data('tab')+']['+index+'][start]" value="'+value.start+'"/>' +
                '<input type="hidden" name="notificacionTramosEnvio['+tab.data('tab')+']['+index+'][end]" value="'+value.end+'"/>';
            notificacionTramosEnvio.append(inputHidden);
        });
        tab.append(notificacionTramosEnvio);
    });
}

function relojMuestraHoraCheckTime(i) {
    if (i < 10) {
        i = "0" + i;
    }
    return i;
}

function relojMuestraHora(id) {
    //id //Es el ID del elemento donde se mostrará el tiempo actual (Ej: #showtime)
    var today = new Date();
    var h = today.getHours();
    var m = today.getMinutes();
    var s = today.getSeconds();
    // add a zero in front of numbers<10
    m = relojMuestraHoraCheckTime(m);
    s = relojMuestraHoraCheckTime(s);
    document.getElementById(id).innerHTML = h + ":" + m + ":" + s;
    t = setTimeout(function () {
        relojMuestraHora(id);
    }, 500);
}

function expiraSesion() {
    if ($("#expira_sesion").length==0)
        return false;

    var refreshTime = 300000; // cada 5 minutos en milisegundos
    window.setInterval(function () {
        $.ajax({
            cache: false,
            type: "GET",
            url: "/api/expiraSesion",
            success: function (data) {
            }
        });
    }, refreshTime);
}

$(document).on('keyup', '.selectSocio .search', function () {
    if (typeof(xhr)!=='undefined') {
        xhr.abort();
    }
    var search = $(this).val(),
        table = $(this).closest('.selectSocio').find('table'),
        body = $(table).find('tbody');
    if (search.length <= 3) {
        body.html('');
        return;
    }
    xhr = $.ajax({
        type: 'GET',
        url: '../sportssuite/manager.php',
        data: {
            op: 'get_user_list',
            name: search
        }
    }).done(function (response) {
        var socios = response.data.socios;
        body.html('');
        var hg = new RegExp(search, "gi");
        socios.forEach(function (e, i) {
            var $row = $('<tr class="pointer" data-id_mst_socios="'+e.id+'">').appendTo(body),
                $check_cell = $('<td>').appendTo($row);
                $('<input type="radio" value="' + e.id + '">').appendTo($check_cell);
            $('<td class="nombreNivel">').appendTo($row).html(e.n.replace(hg, '<strong>' + search + '</strong>'));
            // $('<td>').appendTo($row).html(e.nivel);
        });
    });
});

$(document).on('click','.selectSocio.editarInscrito table tbody tr',function(){
    var idMstSociosSeleccionado = $(this).data('id_mst_socios');
    var inscritoEditando = $(".ver_inscritos_grupo").find('.inscrito.edit');
    var id_reg_inscritos =  inscritoEditando.data('id_reg_inscritos');
    $.get('/api/campeonatoGrupo/inscrito/'+id_reg_inscritos+'/cambiarInscrito/usuarioNuevo/'+idMstSociosSeleccionado,function(response){
        inscritoEditando.find('.nombreApellidos').html(response.nombre_completo);
        inscritoEditando.find('.fecha_nacimiento').html(response.fecha_nacimiento);
        $(inscritoEditando).removeClass('edit');
        $("#modal_c").modal('toggle');
    });
});



$(document).on('click','.cambiarInscrito',function(){
    $(".inscrito").removeClass('edit');
    $(this).closest('.inscrito').addClass('edit');
});



function editarCampeonatoGrupoCompruebaSinInscritos() {

    var modal = $("#editarCampeonatoGrupoCrearGrupo");

    var checked = modal.find("#sin_inscritos").is(':checked');
    if (checked){
        modal.find("#limite_equipos_form_group").addClass('hidden');
        modal.find("#div_sin_inscritos_numero_equipos").removeClass('hidden');
        modal.find(".admin_campeonatos_editar .adminEliminatoriaRankingNumEquipos").removeClass('hidden');
    }else{
        modal.find("#limite_equipos_form_group").removeClass('hidden');
        modal.find("#div_sin_inscritos_numero_equipos").addClass('hidden');
        modal.find(".admin_campeonatos_editar .adminEliminatoriaRankingNumEquipos").addClass('hidden');
    }
}

$(document).on('switchChange.bootstrapSwitch', '#editarCampeonatoGrupoCrearGrupo #sin_inscritos', function (event, state) {
    editarCampeonatoGrupoCompruebaSinInscritos();
});

/*Editar campeonatoGrupo*/

$(document).on('change','.cambiarEquipo #escojerCampeonatoGrupo',function(){
    var selected = $(this).find(":selected");
    if (selected.data('reg_campeonatos_tipo')==1){
        $(".cambiarEquipo #mensajeCampeonatoEliminatoria").removeClass('hidden');
        $(".cambiarEquipo #clasificacionLiga").addClass('hidden');

    }else{
        $(".cambiarEquipo #mensajeCampeonatoEliminatoria").addClass('hidden');
        $(".cambiarEquipo #clasificacionLiga").removeClass('hidden');
    }

});

function isHTML(str) {
    var a = document.createElement('div');
    a.innerHTML = str;
    for (var c = a.childNodes, i = c.length; i--; ) {
        if (c[i].nodeType == 1) return true;
    }
    return false;
}

function stripHTML(dirtyString) {
    var container = document.createElement('div');
    var text = document.createTextNode(dirtyString);
    container.appendChild(text);
    return container.innerHTML; // innerHTML will be a xss safe string

}

//RankingReservaplay


function addPuntuaRankingReservaplayInput(){
    $("#event-form").append('<input type="hidden" name="puntuaRankingReservaplay" value="1"/>');
}


$(document).on('click','#calEventRankingInfo #radioPuntua',function(){
   $("#calEventRankingInfo #puntuaAlertInfo").removeClass('hidden');
    $("#event-form [name=puntuaRankingReservaplay]").remove();
    addPuntuaRankingReservaplayInput();

});
$(document).on('click','#calEventRankingInfo #radioNoPuntua',function(){
    $("#calEventRankingInfo #puntuaAlertInfo").addClass('hidden');
    $("#event-form [name=puntuaRankingReservaplay]").remove();

});

$(function(){
    if($("#calEventRankingInfo #radioPuntua").is(':checked')){
        addPuntuaRankingReservaplayInput();
    }
});

$(function(){
    if($("#calEventRankingInfo #radioPuntua").is(':checked')){
        addPuntuaRankingReservaplayInput();
    }
});

$(document).on('click', '.btn.eliminar_inscrito', function () {
    $(this).closest(".row.inscrito").remove();
    rankingReservaplayAnadirUsuarioCheck();
});

$(function () {
    rankingReservaplayAnadirUsuarioCheck();
});



$('#modificarEquiposPuntuaciones').on('show.bs.collapse', '.collapse', function () {
    $('#modificarEquiposPuntuaciones').find('.collapse.in').collapse('hide');
});

function rankingReservaPlayResetResponseMessage(){
    $('#message-response:not(.ind)').remove();
}

$(document).on('click','.selectSocio.rankingReservaplayCambiarInscritoNuevoEquipo table tbody tr',function(){
    var idMstSociosSeleccionado = $(this).data('id_mst_socios');
    var nombreApellidos = $(this).find('.nombreNivel');
    var inscritoEditando = $("#configurar_equipos").find('.inscrito.edit');
    var usuarioExistente = rankingReservaPlayCompruebaUsuarioExistente(idMstSociosSeleccionado);
    if (usuarioExistente){
        return;
    }
    $("#modal_c").modal('toggle');
    $(inscritoEditando).find('.inscritoNombre').html(nombreApellidos);
    $(inscritoEditando).find('input.selecciona_equipo').attr("name","equipo["+idMstSociosSeleccionado+"]");

});

function rankingReservaplayAnadirUsuarioCheck(){
    rankingReservaPlayResetResponseMessage();
    if ($('.row.inscrito:not(.template)').size() < $("#capacidad_max").val()) {
        $("#anadir_inscrito").removeClass("hidden");
    } else {
        $("#anadir_inscrito").addClass("hidden");
    }
}

function rankingReservaPlayCompruebaUsuarioExistente(idMstSociosSeleccionado){
    var usuarioExistente = false;
    $("#configurarEquiposContenido .inscritos .inscrito .selecciona_equipo").each(function(k,i){
        if ($(i).attr('name')=='equipo['+idMstSociosSeleccionado+']'){
            var html = '<div id="message-response" class="msg msg-error">'+Lang.get('msg.soci_existent')+'</div>';
            $(".rankingReservaplayCambiarInscritoNuevoEquipo .response").html(html);
            $(".rankingReservaplayNuevoInscritoNuevoEquipo .response").html(html);
            usuarioExistente = true;
        }
    });
    return usuarioExistente;
}

$(document).on('click','.selectSocio.rankingReservaplayNuevoInscritoNuevoEquipo table tbody tr',function(){
    var idMstSociosSeleccionado = $(this).data('id_mst_socios');
    var nombreApellidos = $(this).find('.nombreNivel').html();
    var inscritoEditando = $("#configurar_equipos").find('.inscrito.edit');
    $(inscritoEditando).find('.inscritoNombre').html(nombreApellidos);
    //Comprobamos si en la lista de participantes de los equipos existe el inscrito que se esta añadiendo
    var usuarioExistente = rankingReservaPlayCompruebaUsuarioExistente(idMstSociosSeleccionado);
    if (usuarioExistente){
        return;
    }
    //-------
    $("#modal_c").modal('toggle');



    var equipoA = $("#equipoA").val();
    var equipoB = $("#equipoB").val();

    var inscrito = $(".inscrito.template").clone();
    $(inscrito).find(".equipoA").val(equipoA);
    $(inscrito).find(".equipoA").attr('name','equipo['+idMstSociosSeleccionado+']');
    $(inscrito).find(".equipoB").val(equipoB);
    $(inscrito).find(".equipoB").attr('name','equipo['+idMstSociosSeleccionado+']');
    $(inscrito).find(".inscritoNombre").html(nombreApellidos);
    $(inscrito).removeClass('hidden');
    $(inscrito).removeClass('template');
    $(".inscritos").append(inscrito);

    rankingReservaplayAnadirUsuarioCheck();
});

$(document).on('click','#rankingReservaplayMuestraCondiciones',function(){
    $('.rankingReservaplayCondicions').toggle('slow');
});

$(document).on('click','#modificarEquiposPuntuacionesForm .btn',function(){
        $.post('/reserva/configurar_puntuacion/'+$(this).closest('form').data('id_reg_partidos'),{'resultado':$(this).find('input').val()},function(){
        process_response({
            status: 'ok',
            data: {
                msg: Lang.get('msg.CambiosRealizadosCorrectamente')
            }
        }, $("#modificarEquiposPuntuacionesForm"), $("#modificarEquiposPuntuacionesForm").find('.response'));
    });
});

$(document).on('click',"#rankingInfoSaveBtn",function(e){
    e.preventDefault();
    var checked;
    $("#radioPuntua").is(':checked')?checked=1:checked=0;
    var data = {
        'rankingReservaplayPuntua':checked,
    };
    $.post('/api/reserves/'+$("[name=id_reserva]").val()+'/puntuaRankingReservaplay',data,function(res){
        process_response(res,false,$("#calEventRankingInfo #response"));
    });
});

//RankingReservaplay

//Weather Widget
$(document).on('click','.aw-widget-content #link_current',function(e){
    e.preventDefault();
});

$(document).on('click','.btnCopyLink',function(ev){
    //Copia el enlace de la url en el portapapeles
    var textarea = document.createElement('textarea');
    textarea.textContent = window.location.href;
    document.body.appendChild(textarea);

    var selection = document.getSelection();
    var range = document.createRange();
    range.selectNode(textarea);
    selection.removeAllRanges();
    selection.addRange(range);

    try {
        // Now that we've selected the anchor text, execute the copy command
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch(err) {
        console.log('Oops, unable to copy');
    }
    selection.removeAllRanges();
    document.body.removeChild(textarea);

    var copyres = $(this).data('response');
    if (copyres!=='undefined'){
        var copyresObject = $('#'+copyres);
        $(copyresObject).removeClass('hidden');
        setTimeout (function(){
            $(copyresObject).addClass('hidden');
        }, 5000);
    }

    ev.preventDefault();
    ev.stopPropagation();
    if ($(this).data('callback')!==undefined){
        executeFunctionByName($(this).data('callback'));
    }
});

$(document).on('click','.btnCopyLinkcopyElementId',function(ev) {
    //Copia el enlace del elemento indicado en atributo data-id (del enlace pulsado) en el portapapeles
    //console.log(ev);
    var attrId = ev.currentTarget.attributes['data-id'];
    //console.log(attrId);
    //console.log(attrId.nodeValue);
    var paragraf = document.createElement('P');
    paragraf.innerText = document.getElementById(attrId.nodeValue).value;
    // console.log(paragraf);
    // console.log(paragraf.innerText);
    document.body.appendChild(paragraf);

    var selection = document.getSelection();
    var range = document.createRange();
    range.selectNode(paragraf);
    selection.removeAllRanges();
    selection.addRange(range);

    try {
        // Now that we've selected the anchor text, execute the copy command
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
    } catch (err) {
        console.log('Oops, unable to copy');
    }
    selection.removeAllRanges();
    document.body.removeChild(paragraf);

    var copyres = $(this).data('response');
    if (copyres !== 'undefined') {
        var copyresObject = $('#' + copyres);
        $(copyresObject).removeClass('hidden');
        setTimeout(function () {
            $(copyresObject).addClass('hidden');
        }, 5000);
    }

    ev.preventDefault();
    ev.stopPropagation();
});

$(function(){
    if ($(".exportPDF").length>0){
        // Import DejaVu Sans font for embedding
        // NOTE: Only required if the Kendo UI stylesheets are loaded
        // from a different origin, e.g. cdn.kendostatic.com
        kendo.pdf.defineFont({
            "DejaVu Sans"             : "/fonts/kendo/DejaVuSans.ttf",
            "DejaVu Sans|Bold"        : "/fonts/kendo/DejaVuSans-Bold.ttf",
            "DejaVu Sans|Bold|Italic" : "/fonts/kendo/DejaVuSans-Oblique.ttf",
            "DejaVu Sans|Italic"      : "/fonts/kendo/DejaVuSans-Oblique.ttf"
        });

        var script = document.createElement('script');
        script.onload = function () {
            //do stuff with the script
        };
        script.src = '/kendo/js/pako_deflate.min.js';
        document.head.appendChild(script); //or something of the likes
        //Load Pako ZLIB library to enable PDF compression
    }
});

$('body').on('click', '#asistenciaCheck', function () {

    var id = $(this).attr('data-id');
    var url = '/api/reserva/factura/' + id + '/toggleAsistencia';

    $.get(url, function (data) {
        //console.log(data);
    });
});

function actualizarCheckAsistencia(data){
    for (var i = 0; i <= data.length-1; i++) {
        var check = $("body").find("[data-id='" + data[i]['id_reg_factura'] + "']");
        if (check.length > 0)
        {
            check[0].checked =  data[i]['asistencia'];
        }
    }
}

$('body').on('click', '#marcarAssistenciaTots', function () {

    var id_reg_reserva = $(this).attr('data-id');
    var url = '/api/reserva/' + id_reg_reserva + '/factura/marcarAsistenciaTodos';

    $.get(url, function (data) {
        actualizarCheckAsistencia(data);
    });
});

$('body').on('click', '#desmarcarAssistenciaTots', function () {

    var id_reg_reserva = $(this).attr('data-id');
    var url = '/api/reserva/' + id_reg_reserva + '/factura/desmarcarAsistenciaTodos';

    $.get(url, function (data) {
        actualizarCheckAsistencia(data);
    });
});

$('body').on('click', '#marcar_asistencia_equipo', function () {

    var id_reg_reserva = $(this).attr('data-id');
    var html = $(this).parent();
    var id_mst_etiqueta = $(html).find('#sel_asistencia').val();
    var cantidad = $(html).find('#num_asistencia').val();

    var url = '/api/reserva/' + id_reg_reserva + '/etiqueta/' + id_mst_etiqueta + '/marcar_asistencia_equipo/' + cantidad;
    $.get(url, function (data) {
        actualizarCheckAsistencia(data);
    });
});


/* Ranking Nivel ******************/

if ($("#rankingNivelChart").length>0) {
    $(document).ready(function () {
        $.fn.dataTable.moment( 'DD/MM/YYYY');
        $('#rankingNivelTable').DataTable({
            "ajax": '/api/rankingNivel',
            language: {
                url: '/vendor/datatables-i18n/i18n/'+lang+'.json'
            },
            "order": [[ 5, "desc" ]]
        });
        if ($('#nivelesChart').val()!=='') {
            var ctx = document.getElementById("rankingNivelChart");
            var myChart = new Chart(ctx, {
                type: 'line',
                data: {
                labels: $('#nivelesLabels').val().split(','),
                    datasets: [{
                        label: Lang.get('frm.Nivel'),
                        data: $('#nivelesChart').val().split(','),
                        backgroundColor: [
                            'rgba(255, 255, 255, 0)',
                        ],
                        borderColor: [
                            'rgba(33,150,243,1)',

                        ],
                        borderWidth: 2
                    }]
                },
                options: {
                    scales: {
                        xAxes: [{
                            ticks: {
                                autoSkip: false,
                                maxRotation: 80,
                                minRotation: 80
                            }
                        }],
                        yAxes: [{
                            ticks: {
//                            beginAtZero:true
                            }
                        }]
                    }
                }
            });
        }else{
            $("#rankingNivelChart").addClass('hidden');
        }
    });
}

function slugify(text)
{
    var str = text.toString().toLowerCase();
    str = removeDiacritics(str);
    return str
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
        .replace(/\-\-+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '')             // Trim - from end of text
        .replace(/\-/g, '')             // Replace '-' with nothing
        .replace(/\_/g, '')             // Replace '_' with nothing
        .replace(/\./g, '');             // Replace '.' with nothing
}

/*Numsocio.
* -------------------------------------------------*/

$(".cal_new_user [name=mail]").keyup(function () {
    var this_ = $(this);
    var res = this_.val().split("@");
    res = slugify(res[0]);
    $("[name=numsocio]").val(res);
});



/***************/


//var $buoop = {required:{e:-4,f:-3,o:-3,s:-1,c:-3},insecure:true,api:2019.07,noclose:true,test:false };
//function $buo_f(){
//    var e = document.createElement("script");
//    e.src = "/vendor/update/update.min.js";
//    document.body.appendChild(e);
//};
//try {document.addEventListener("DOMContentLoaded", $buo_f,false);}
//catch(e){window.attachEvent("onload", $buo_f);}


$('#select_socios_modal').on('shown.bs.modal', function (e) {
    $('#search_input_socios').focus();
})

